export const net_lung = {
  nodes: [
    {
      data: {
        id: "SRC",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1803.4569225, y: -468.905476415218 },
    },
    {
      data: { id: "SLC44A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 782.026622664098 },
    },
    {
      data: {
        id: "KEAP1",
        oncg: 0,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1644.92788896482, y: 650.674548469145 },
    },
    {
      data: { id: "TRIM32", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 571.545070599999 },
    },
    {
      data: { id: "FBXL12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 729.406234648343 },
    },
    {
      data: { id: "ELOC", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 624.165458616162 },
    },
    {
      data: { id: "HMOX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -686.724372700541 },
    },
    {
      data: { id: "HECTD1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 466.304294567994 },
    },
    {
      data: { id: "ELOB", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 413.683906552035 },
    },
    {
      data: { id: "RNF41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 361.063518535988 },
    },
    {
      data: { id: "RBX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 308.443130519913 },
    },
    {
      data: { id: "HERC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 518.924682583866 },
    },
    {
      data: { id: "LRRC41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1898.77473451699, y: 676.785846632238 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: 32.0063694109696 },
    },
    {
      data: {
        id: "UBE2C",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1644.92788896482, y: 817.839768399844 },
    },
    {
      data: {
        id: "NFKB1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1265.20012544531, y: -39.9257974482059 },
    },
    {
      data: {
        id: "PTTG1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -733.625471242016, y: -1010.68201558264 },
    },
    {
      data: {
        id: "CCND1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 56.04079,
      },
      position: { x: -301.31753481267, y: -384.511712997733 },
    },
    {
      data: {
        id: "TP53",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 115.9778,
      },
      position: { x: -472.876226718841, y: 1015.76067333736 },
    },
    {
      data: {
        id: "APC",
        oncg: 0,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -301.31753481267, y: -135.02736955554 },
    },
    {
      data: {
        id: "PSMA6",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -301.31753481267, y: -73.1550589234862 },
    },
    {
      data: {
        id: "BAP1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -301.31753481267, y: 50.6500199438129 },
    },
    {
      data: { id: "AP2M1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -1059.23532652613 },
    },
    {
      data: {
        id: "MAPK1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 40,
      },
      position: { x: -1803.4569225, y: -1166.90054315175 },
    },
    {
      data: { id: "GNG5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -796.143047347127 },
    },
    {
      data: { id: "PRKAR2A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -1124.39907128639 },
    },
    {
      data: { id: "ARF6", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -850.852384670158 },
    },
    {
      data: { id: "PRKAR2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -1014.98039664001 },
    },
    {
      data: { id: "ATP1B1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -1069.68973396313 },
    },
    {
      data: { id: "RHOA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -741.433710023863 },
    },
    {
      data: { id: "AP2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -897.567297302245 },
    },
    {
      data: { id: "RAB2A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -905.561721993364 },
    },
    {
      data: {
        id: "AKT1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 40,
      },
      position: { x: -1803.4569225, y: -749.652730153882 },
    },
    {
      data: {
        id: "FOS",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1803.4569225, y: -580.722752880575 },
    },
    {
      data: {
        id: "IL6",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1803.4569225, y: -865.684225632817 },
    },
    {
      data: {
        id: "JUN",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 48.20285,
      },
      position: { x: -1803.4569225, y: -808.170170633101 },
    },
    {
      data: {
        id: "PTGS2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -301.31753481267, y: -321.672080710373 },
    },
    {
      data: {
        id: "PIK3CA",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 55.17848,
      },
      position: { x: -1803.4569225, y: -1108.18242557668 },
    },
    {
      data: {
        id: "TRIM11",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1644.92788896482, y: 706.396288446132 },
    },
    {
      data: {
        id: "PRKN",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: -1644.92788896482, y: 595.152099410257 },
    },
    {
      data: {
        id: "UBA7",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -1644.92788896482, y: 762.317319340927 },
    },
    {
      data: {
        id: "YY1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1644.92788896482, y: 424.598933874755 },
    },
    {
      data: {
        id: "CREBBP",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -301.31753481267, y: -259.860227681801 },
    },
    {
      data: {
        id: "PCNA",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -472.876226718841, y: 853.966554165409 },
    },
    {
      data: {
        id: "PER1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1644.92788896482, y: 123.191352302538 },
    },
    {
      data: { id: "GTF2F2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 694.145332636004 },
    },
    {
      data: {
        id: "BRF2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: 347.531477193685, y: 582.577681652347 },
    },
    {
      data: { id: "EXOSC5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2589.54499813646, y: -764.508056717399 },
    },
    {
      data: {
        id: "TDP2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -2463.79577100686, y: -764.529284165963 },
    },
    {
      data: { id: "TLE5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -385.738465262098 },
    },
    {
      data: {
        id: "MYC",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 116.9607,
      },
      position: { x: 639.435476386995, y: -32.371854683046 },
    },
    {
      data: {
        id: "TLE1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 28.84499,
      },
      position: { x: -540.723295682107, y: -327.390722666737 },
    },
    {
      data: { id: "SCCPDH", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -1179.10840860968 },
    },
    {
      data: {
        id: "HGF",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 45.78857,
      },
      position: { x: -1803.4569225, y: -1224.21392105573 },
    },
    {
      data: { id: "RIPK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1401.28733946542, y: -209.816917636685 },
    },
    {
      data: { id: "HDAC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 410.425641457263 },
    },
    {
      data: { id: "ERC1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1401.28733946542, y: -157.036601205929 },
    },
    {
      data: { id: "MOV10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 453.001035645617, y: 5.34566358540973 },
    },
    {
      data: { id: "CEP55", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -1005.34598345152 },
    },
    {
      data: {
        id: "ECT2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -733.625471242016, y: -1112.09078964328 },
    },
    {
      data: { id: "CPSF3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 551.930503649417 },
    },
    {
      data: {
        id: "RBM5",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 347.531477193685, y: 525.421016132826 },
    },
    {
      data: {
        id: "YBX1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 347.531477193685, y: 411.497111474298 },
    },
    {
      data: { id: "PDZD11", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -682.009925003716 },
    },
    {
      data: {
        id: "KIF4A",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -733.625471242016, y: -783.179825778368 },
    },
    {
      data: { id: "TCF12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -148.623240278351 },
    },
    {
      data: {
        id: "TWIST1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -301.31753481267, y: -11.2222906880955 },
    },
    {
      data: {
        id: "YEATS4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 347.531477193685, y: 698.448718214164 },
    },
    {
      data: { id: "GDF15", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 941.162559681983 },
    },
    {
      data: { id: "F2RL1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -960.271059316686 },
    },
    {
      data: {
        id: "GRP",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1803.4569225, y: -977.100147906408 },
    },
    {
      data: { id: "TLE3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -208.833110174791 },
    },
    {
      data: { id: "REEP5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: 92.2162393074096 },
    },
    {
      data: {
        id: "MAP2K4",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1265.20012544531, y: -159.922408200425 },
    },
    {
      data: {
        id: "TRAF6",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 48.20285,
      },
      position: { x: -1265.20012544531, y: 20.4228971013185 },
    },
    {
      data: {
        id: "PRKCI",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -1265.20012544531, y: -99.9241028244174 },
    },
    {
      data: {
        id: "CAV1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: 639.435476386995, y: -194.451209306688 },
    },
    {
      data: {
        id: "CYLD",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1265.20012544531, y: -219.628722598809 },
    },
    {
      data: { id: "GORASP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -1113.12466960074 },
    },
    {
      data: {
        id: "CDH1",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 40,
      },
      position: { x: -472.876226718841, y: 561.383093249663 },
    },
    {
      data: { id: "DNMT1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 469.396410148885 },
    },
    {
      data: { id: "RAB7A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -951.456640376855 },
    },
    {
      data: {
        id: "RBL2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -472.876226718841, y: 387.105365681752 },
    },
    {
      data: { id: "PTGES2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -269.04298007126 },
    },
    {
      data: { id: "SNIP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -88.4133703819107 },
    },
    {
      data: { id: "ACADM", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: -28.2035004854122 },
    },
    {
      data: { id: "FBN2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 367.035656100246, y: -930.018814642476 },
    },
    {
      data: {
        id: "PDCD1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 482.353934725072, y: -901.074940693179 },
    },
    {
      data: { id: "CSNK2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 1000.13332837375 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: 453.001035645617, y: -250.996697243273 },
    },
    {
      data: {
        id: "PTEN",
        oncg: 0,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 61.44634,
      },
      position: { x: 639.435476386995, y: -133.343338215054 },
    },
    {
      data: {
        id: "EGFR",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 116.9607,
      },
      position: { x: -733.625471242016, y: -896.930920680477 },
    },
    {
      data: { id: "BRD4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 453.001035645617, y: -122.825516828946 },
    },
    {
      data: { id: "ITGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 453.001035645617, y: -315.082287450466 },
    },
    {
      data: { id: "GOLGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -1167.01401267541 },
    },
    {
      data: {
        id: "ARCN1",
        oncg: 0,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -733.625471242016, y: -1162.69627987682 },
    },
    {
      data: { id: "RAB1A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -789.788611152966 },
    },
    {
      data: {
        id: "PTPN13",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "pink",
        size: 28.84499,
      },
      position: { x: -2018.35267302797, y: -576.025176126903 },
    },
    {
      data: {
        id: "STAT3",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 60.73178,
      },
      position: { x: -1803.4569225, y: -408.581942073078 },
    },
    {
      data: {
        id: "DNMT3A",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1114.55744569394, y: 842.295953079312 },
    },
    {
      data: { id: "MAT2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1262.4616359497, y: 839.904238343941 },
    },
    {
      data: {
        id: "KIF5B",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -733.625471242016, y: -732.62378394291 },
    },
    {
      data: { id: "POLA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 646.308716223811 },
    },
    {
      data: {
        id: "RB1",
        oncg: 0,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 56.87734,
      },
      position: { x: -472.876226718841, y: 913.176222133187 },
    },
    {
      data: {
        id: "BCL2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -1803.4569225, y: -1281.92865315136 },
    },
    {
      data: { id: "IDE", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1262.4616359497, y: 969.402348023482 },
    },
    {
      data: {
        id: "PTRH2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1114.55744569394, y: 919.423138273275 },
    },
    {
      data: {
        id: "ASCL1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 47.02669,
      },
      position: { x: -301.31753481267, y: -197.4437986187 },
    },
    {
      data: {
        id: "ERBB3",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1644.92788896482, y: 287.64621642585 },
    },
    {
      data: { id: "PRIM1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 705.279484915434 },
    },
    {
      data: { id: "POLA1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 587.33794753216 },
    },
    {
      data: { id: "CRTC3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 367.035656100246, y: -722.529879128501 },
    },
    {
      data: {
        id: "ATF3",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 482.353934725072, y: -707.449594596249 },
    },
    {
      data: { id: "GPX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 882.191790990389 },
    },
    {
      data: { id: "DNA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 764.250253607086 },
    },
    {
      data: { id: "CSNK2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 823.221022298767 },
    },
    {
      data: {
        id: "ERBB2",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 82.03132,
      },
      position: { x: -1644.92788896482, y: 356.122575150317 },
    },
    {
      data: { id: "ECSIT", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1401.28733946542, y: -104.256284774883 },
    },
    {
      data: {
        id: "SETDB1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -472.876226718841, y: 736.626442812469 },
    },
    {
      data: { id: "PLOD2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -740.49215063537, y: 528.367178840566 },
    },
    {
      data: { id: "SAV1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -92.7246600754841, y: -1028.02723622701 },
    },
    {
      data: {
        id: "LIMD1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 20.3482909192448, y: -1029.88202223263 },
    },
    {
      data: { id: "RAB5C", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -735.899268078327 },
    },
    {
      data: {
        id: "DLC1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -1803.4569225, y: -692.540029345932 },
    },
    {
      data: {
        id: "YAP1",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 53.36803,
      },
      position: { x: 20.3482909192448, y: -913.972936559209 },
    },
    {
      data: { id: "STK4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -92.7246600755025, y: -963.941646019812 },
    },
    {
      data: { id: "STK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -92.7246600755025, y: -899.856055812677 },
    },
    {
      data: {
        id: "SETD2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -472.876226718841, y: 678.439198133476 },
    },
    {
      data: { id: "TOMM70", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1262.4616359497, y: 904.653293183711 },
    },
    {
      data: { id: "TMED5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 367.035656100246, y: -860.85583613775 },
    },
    {
      data: {
        id: "WNT7A",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: 482.353934725072, y: -836.449125352134 },
    },
    {
      data: {
        id: "KIT",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 52.41483,
      },
      position: { x: -1644.92788896482, y: 537.437450253997 },
    },
    {
      data: { id: "RAB14", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 367.035656100246, y: -791.692857633111 },
    },
    {
      data: {
        id: "HPGD",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 482.353934725072, y: -771.886334992531 },
    },
    {
      data: { id: "NDUFAF2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 453.001035645617, y: -58.739926621812 },
    },
    {
      data: { id: "SLU7", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 409.715674662743 },
    },
    {
      data: {
        id: "MYB",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 347.531477193685, y: 468.375615293411 },
    },
    {
      data: {
        id: "TTF1",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 45.78857,
      },
      position: { x: -472.876226718841, y: 619.911145691555 },
    },
    {
      data: {
        id: "MET",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 72.17652,
      },
      position: { x: -1803.4569225, y: -1041.2365470703 },
    },
    {
      data: {
        id: "METTL3",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 55.17848,
      },
      position: { x: 347.531477193685, y: 640.568832273409 },
    },
    {
      data: {
        id: "CRKL",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 44.4796,
      },
      position: { x: 639.435476386995, y: -314.331023667881 },
    },
    {
      data: {
        id: "TGFBI",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 639.435476386995, y: -254.157523704984 },
    },
    {
      data: { id: "NUP62", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -1233.8177459328 },
    },
    {
      data: { id: "IBTK", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2018.35267302797, y: -632.015035377249 },
    },
    {
      data: {
        id: "SYK",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -1803.4569225, y: -636.430714017312 },
    },
    {
      data: {
        id: "RET",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 103.353,
      },
      position: { x: -1644.92788896482, y: 205.418784364165 },
    },
    {
      data: { id: "UBAP2L", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -540.723295682107, y: 152.42610920385 },
    },
    {
      data: {
        id: "EZH2",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 49.32424,
      },
      position: { x: -472.876226718841, y: 795.324899135855 },
    },
    {
      data: {
        id: "LATS2",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 20.3482909191807, y: -972.209524089121 },
    },
    {
      data: {
        id: "SIRT7",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -472.876226718841, y: 503.252649864472 },
    },
    {
      data: { id: "TBK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1401.28733946542, y: -51.4759683441572 },
    },
    {
      data: { id: "SNRNP48", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 480.823089156109 },
    },
    {
      data: {
        id: "ERBB4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1644.92788896482, y: 479.922092015777 },
    },
    {
      data: {
        id: "FOXM1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: -733.625471242016, y: -1061.38640261298 },
    },
    {
      data: { id: "CENPF", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -953.996943602979, y: -843.677954227605 },
    },
    {
      data: { id: "CWC27", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 623.037918142638 },
    },
    {
      data: {
        id: "RASSF1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 52.41483,
      },
      position: { x: 21.7714080137177, y: -847.77462947763 },
    },
    {
      data: {
        id: "ETS1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 639.435476386995, y: 61.8683307504313 },
    },
    {
      data: {
        id: "CXCR4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1803.4569225, y: -921.392186769642 },
    },
    {
      data: { id: "PMPCA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 453.001035645617, y: -186.911107036168 },
    },
    {
      data: { id: "EXOSC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2589.54499813646, y: -692.449786428389 },
    },
    {
      data: { id: "CSDE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 267.500845676068 },
    },
    {
      data: { id: "RNPC3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 156.765802874811, y: 338.608260169347 },
    },
    {
      data: { id: "HS6ST2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 367.035656100246, y: -999.181793147056 },
    },
    {
      data: {
        id: "GPC5",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 482.353934725072, y: -965.637731052812 },
    },
    {
      data: { id: "EXOSC8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2589.54499813646, y: -836.566327006059 },
    },
    {
      data: {
        id: "SIRT3",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -472.876226718841, y: 445.17900777317 },
    },
    {
      data: {
        id: "ROCK1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1803.4569225, y: -525.01479174378 },
    },
    {
      data: { id: "TYK2", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -1610.4800662718, y: -835.422199896261 },
    },
    {
      data: { id: "HLA-G", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: 613.544753190631, y: -1035.94609053553 },
    },
    {
      data: {
        id: "EGR1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 480.916442710453, y: -1040.06171589214 },
    },
    {
      data: { id: "IFNAR2", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -1610.4800662718, y: -911.806832583491 },
    },
    {
      data: { id: "NOTCH4", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -504.066628910491, y: -813.001396050543 },
    },
    {
      data: {
        id: "STK11",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 85.08642,
      },
      position: { x: -2383.07320860227, y: -36.1809499617039 },
    },
    {
      data: { id: "MARK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: -78.9505657116912 },
    },
    {
      data: { id: "RAB8A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: 141.552015275162 },
    },
    {
      data: {
        id: "RAP1A",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -2383.07320860227, y: -103.094761876734 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: 196.677660521984 },
    },
    {
      data: {
        id: "RAF1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -2383.07320860227, y: 91.8716037388121 },
    },
    {
      data: {
        id: "NRAS",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 52.41483,
      },
      position: { x: -2383.07320860227, y: -326.435972716015 },
    },
    {
      data: {
        id: "MARK2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 48.20285,
      },
      position: { x: -2571.63309241608, y: 86.4263700284268 },
    },
    {
      data: { id: "MIB1", oncg: 0, tsg: 1, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: -23.8249204649561 },
    },
    {
      data: {
        id: "SOX9",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -2383.07320860227, y: 200.288918998621 },
    },
    {
      data: { id: "AKAP9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: -134.076210958368 },
    },
    {
      data: {
        id: "CACNA2D3",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -2383.07320860227, y: 146.465266043965 },
    },
    {
      data: { id: "MARK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: 31.3007247818372 },
    },
    {
      data: {
        id: "PTGDR",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 58.48035,
      },
      position: { x: -2383.07320860227, y: 34.197904031117 },
    },
    {
      data: { id: "RALA", oncg: 0, tsg: 1, driv: 0, type: "pink", size: 40 },
      position: { x: -2571.63309241608, y: -189.201856205074 },
    },
    {
      data: {
        id: "KRAS",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 116.9607,
      },
      position: { x: -2383.07320860227, y: -213.706604439295 },
    },
  ],

  edges: [
    {
      data: {
        id: "SLC44A2-KEAP1",
        source: "SLC44A2",
        target: "KEAP1",
        weight: 1,
      },
    },
    {
      data: {
        id: "TRIM32-KEAP1",
        source: "TRIM32",
        target: "KEAP1",
        weight: 1,
      },
    },
    {
      data: {
        id: "TRIM32-TRIM11",
        source: "TRIM32",
        target: "TRIM11",
        weight: 1,
      },
    },
    {
      data: { id: "TRIM32-UBA7", source: "TRIM32", target: "UBA7", weight: 1 },
    },
    {
      data: {
        id: "TRIM32-UBE2C",
        source: "TRIM32",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: { id: "TRIM32-PRKN", source: "TRIM32", target: "PRKN", weight: 1 },
    },
    {
      data: {
        id: "FBXL12-KEAP1",
        source: "FBXL12",
        target: "KEAP1",
        weight: 1,
      },
    },
    {
      data: { id: "FBXL12-UBA7", source: "FBXL12", target: "UBA7", weight: 1 },
    },
    {
      data: {
        id: "FBXL12-TRIM11",
        source: "FBXL12",
        target: "TRIM11",
        weight: 1,
      },
    },
    {
      data: {
        id: "FBXL12-UBE2C",
        source: "FBXL12",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: { id: "FBXL12-PRKN", source: "FBXL12", target: "PRKN", weight: 1 },
    },
    { data: { id: "ELOC-KEAP1", source: "ELOC", target: "KEAP1", weight: 1 } },
    {
      data: { id: "ELOC-TRIM11", source: "ELOC", target: "TRIM11", weight: 1 },
    },
    { data: { id: "ELOC-UBE2C", source: "ELOC", target: "UBE2C", weight: 1 } },
    { data: { id: "ELOC-PRKN", source: "ELOC", target: "PRKN", weight: 1 } },
    { data: { id: "ELOC-UBA7", source: "ELOC", target: "UBA7", weight: 1 } },
    {
      data: { id: "HMOX1-KEAP1", source: "HMOX1", target: "KEAP1", weight: 1 },
    },
    {
      data: { id: "HMOX1-MAPK1", source: "HMOX1", target: "MAPK1", weight: 1 },
    },
    { data: { id: "HMOX1-AKT1", source: "HMOX1", target: "AKT1", weight: 1 } },
    { data: { id: "HMOX1-FOS", source: "HMOX1", target: "FOS", weight: 1 } },
    { data: { id: "HMOX1-IL6", source: "HMOX1", target: "IL6", weight: 1 } },
    { data: { id: "HMOX1-JUN", source: "HMOX1", target: "JUN", weight: 1 } },
    {
      data: { id: "HMOX1-PTGS2", source: "HMOX1", target: "PTGS2", weight: 1 },
    },
    {
      data: {
        id: "HMOX1-PIK3CA",
        source: "HMOX1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    {
      data: {
        id: "HECTD1-KEAP1",
        source: "HECTD1",
        target: "KEAP1",
        weight: 1,
      },
    },
    {
      data: {
        id: "HECTD1-TRIM11",
        source: "HECTD1",
        target: "TRIM11",
        weight: 1,
      },
    },
    {
      data: { id: "HECTD1-UBA7", source: "HECTD1", target: "UBA7", weight: 1 },
    },
    {
      data: {
        id: "HECTD1-UBE2C",
        source: "HECTD1",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: { id: "HECTD1-PRKN", source: "HECTD1", target: "PRKN", weight: 1 },
    },
    { data: { id: "ELOB-KEAP1", source: "ELOB", target: "KEAP1", weight: 1 } },
    { data: { id: "ELOB-UBE2C", source: "ELOB", target: "UBE2C", weight: 1 } },
    {
      data: { id: "ELOB-TRIM11", source: "ELOB", target: "TRIM11", weight: 1 },
    },
    { data: { id: "ELOB-UBA7", source: "ELOB", target: "UBA7", weight: 1 } },
    { data: { id: "ELOB-PRKN", source: "ELOB", target: "PRKN", weight: 1 } },
    {
      data: { id: "RNF41-KEAP1", source: "RNF41", target: "KEAP1", weight: 1 },
    },
    {
      data: { id: "RNF41-ERBB3", source: "RNF41", target: "ERBB3", weight: 1 },
    },
    {
      data: { id: "RNF41-ERBB2", source: "RNF41", target: "ERBB2", weight: 1 },
    },
    { data: { id: "RNF41-EGFR", source: "RNF41", target: "EGFR", weight: 1 } },
    {
      data: {
        id: "RNF41-TRIM11",
        source: "RNF41",
        target: "TRIM11",
        weight: 1,
      },
    },
    { data: { id: "RNF41-KIT", source: "RNF41", target: "KIT", weight: 1 } },
    { data: { id: "RNF41-MET", source: "RNF41", target: "MET", weight: 1 } },
    { data: { id: "RNF41-UBA7", source: "RNF41", target: "UBA7", weight: 1 } },
    {
      data: { id: "RNF41-ERBB4", source: "RNF41", target: "ERBB4", weight: 1 },
    },
    { data: { id: "RNF41-RET", source: "RNF41", target: "RET", weight: 1 } },
    {
      data: { id: "RNF41-UBE2C", source: "RNF41", target: "UBE2C", weight: 1 },
    },
    { data: { id: "RNF41-PRKN", source: "RNF41", target: "PRKN", weight: 1 } },
    { data: { id: "RBX1-KEAP1", source: "RBX1", target: "KEAP1", weight: 1 } },
    {
      data: { id: "RBX1-TRIM11", source: "RBX1", target: "TRIM11", weight: 1 },
    },
    { data: { id: "RBX1-PRKN", source: "RBX1", target: "PRKN", weight: 1 } },
    { data: { id: "RBX1-APC", source: "RBX1", target: "APC", weight: 1 } },
    { data: { id: "RBX1-UBA7", source: "RBX1", target: "UBA7", weight: 1 } },
    { data: { id: "RBX1-YY1", source: "RBX1", target: "YY1", weight: 1 } },
    { data: { id: "RBX1-PSMA6", source: "RBX1", target: "PSMA6", weight: 1 } },
    {
      data: { id: "RBX1-CREBBP", source: "RBX1", target: "CREBBP", weight: 1 },
    },
    { data: { id: "RBX1-PCNA", source: "RBX1", target: "PCNA", weight: 1 } },
    { data: { id: "RBX1-UBE2C", source: "RBX1", target: "UBE2C", weight: 1 } },
    { data: { id: "RBX1-PER1", source: "RBX1", target: "PER1", weight: 1 } },
    {
      data: { id: "HERC2-KEAP1", source: "HERC2", target: "KEAP1", weight: 1 },
    },
    { data: { id: "HERC2-UBA7", source: "HERC2", target: "UBA7", weight: 1 } },
    {
      data: { id: "HERC2-UBE2C", source: "HERC2", target: "UBE2C", weight: 1 },
    },
    { data: { id: "HERC2-PRKN", source: "HERC2", target: "PRKN", weight: 1 } },
    {
      data: {
        id: "HERC2-TRIM11",
        source: "HERC2",
        target: "TRIM11",
        weight: 1,
      },
    },
    {
      data: {
        id: "LRRC41-KEAP1",
        source: "LRRC41",
        target: "KEAP1",
        weight: 1,
      },
    },
    {
      data: {
        id: "LRRC41-TRIM11",
        source: "LRRC41",
        target: "TRIM11",
        weight: 1,
      },
    },
    {
      data: { id: "LRRC41-UBA7", source: "LRRC41", target: "UBA7", weight: 1 },
    },
    {
      data: {
        id: "LRRC41-UBE2C",
        source: "LRRC41",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: { id: "LRRC41-PRKN", source: "LRRC41", target: "PRKN", weight: 1 },
    },
    {
      data: { id: "PSMD8-UBE2C", source: "PSMD8", target: "UBE2C", weight: 1 },
    },
    {
      data: { id: "PSMD8-NFKB1", source: "PSMD8", target: "NFKB1", weight: 1 },
    },
    {
      data: { id: "PSMD8-PTTG1", source: "PSMD8", target: "PTTG1", weight: 1 },
    },
    {
      data: { id: "PSMD8-CCND1", source: "PSMD8", target: "CCND1", weight: 1 },
    },
    { data: { id: "PSMD8-TP53", source: "PSMD8", target: "TP53", weight: 1 } },
    { data: { id: "PSMD8-APC", source: "PSMD8", target: "APC", weight: 1 } },
    {
      data: { id: "PSMD8-PSMA6", source: "PSMD8", target: "PSMA6", weight: 1 },
    },
    { data: { id: "PSMD8-BAP1", source: "PSMD8", target: "BAP1", weight: 1 } },
    {
      data: { id: "AP2M1-MAPK1", source: "AP2M1", target: "MAPK1", weight: 1 },
    },
    {
      data: { id: "AP2M1-ARCN1", source: "AP2M1", target: "ARCN1", weight: 1 },
    },
    { data: { id: "AP2M1-EGFR", source: "AP2M1", target: "EGFR", weight: 1 } },
    {
      data: { id: "AP2M1-KIF4A", source: "AP2M1", target: "KIF4A", weight: 1 },
    },
    { data: { id: "GNG5-MAPK1", source: "GNG5", target: "MAPK1", weight: 1 } },
    { data: { id: "GNG5-GRP", source: "GNG5", target: "GRP", weight: 1 } },
    {
      data: { id: "GNG5-PIK3CA", source: "GNG5", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "GNG5-AKT1", source: "GNG5", target: "AKT1", weight: 1 } },
    { data: { id: "GNG5-CXCR4", source: "GNG5", target: "CXCR4", weight: 1 } },
    { data: { id: "GNG5-PTGDR", source: "GNG5", target: "PTGDR", weight: 1 } },
    {
      data: {
        id: "PRKAR2A-MAPK1",
        source: "PRKAR2A",
        target: "MAPK1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKAR2A-BCL2",
        source: "PRKAR2A",
        target: "BCL2",
        weight: 1,
      },
    },
    { data: { id: "ARF6-MAPK1", source: "ARF6", target: "MAPK1", weight: 1 } },
    { data: { id: "ARF6-HGF", source: "ARF6", target: "HGF", weight: 1 } },
    {
      data: { id: "ARF6-PIK3CA", source: "ARF6", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "ARF6-EGFR", source: "ARF6", target: "EGFR", weight: 1 } },
    { data: { id: "ARF6-SRC", source: "ARF6", target: "SRC", weight: 1 } },
    { data: { id: "ARF6-MET", source: "ARF6", target: "MET", weight: 1 } },
    {
      data: {
        id: "PRKAR2B-MAPK1",
        source: "PRKAR2B",
        target: "MAPK1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKAR2B-BCL2",
        source: "PRKAR2B",
        target: "BCL2",
        weight: 1,
      },
    },
    {
      data: {
        id: "ATP1B1-MAPK1",
        source: "ATP1B1",
        target: "MAPK1",
        weight: 1,
      },
    },
    { data: { id: "RHOA-MAPK1", source: "RHOA", target: "MAPK1", weight: 1 } },
    { data: { id: "RHOA-CCND1", source: "RHOA", target: "CCND1", weight: 1 } },
    { data: { id: "RHOA-ECT2", source: "RHOA", target: "ECT2", weight: 1 } },
    { data: { id: "RHOA-CDH1", source: "RHOA", target: "CDH1", weight: 1 } },
    {
      data: { id: "RHOA-PIK3CA", source: "RHOA", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "RHOA-ERBB2", source: "RHOA", target: "ERBB2", weight: 1 } },
    { data: { id: "RHOA-AKT1", source: "RHOA", target: "AKT1", weight: 1 } },
    { data: { id: "RHOA-EGFR", source: "RHOA", target: "EGFR", weight: 1 } },
    { data: { id: "RHOA-DLC1", source: "RHOA", target: "DLC1", weight: 1 } },
    { data: { id: "RHOA-FOS", source: "RHOA", target: "FOS", weight: 1 } },
    { data: { id: "RHOA-KIF5B", source: "RHOA", target: "KIF5B", weight: 1 } },
    { data: { id: "RHOA-MET", source: "RHOA", target: "MET", weight: 1 } },
    { data: { id: "RHOA-CAV1", source: "RHOA", target: "CAV1", weight: 1 } },
    { data: { id: "RHOA-SRC", source: "RHOA", target: "SRC", weight: 1 } },
    { data: { id: "RHOA-JUN", source: "RHOA", target: "JUN", weight: 1 } },
    { data: { id: "RHOA-SYK", source: "RHOA", target: "SYK", weight: 1 } },
    { data: { id: "RHOA-MYC", source: "RHOA", target: "MYC", weight: 1 } },
    { data: { id: "RHOA-ROCK1", source: "RHOA", target: "ROCK1", weight: 1 } },
    { data: { id: "RHOA-RAF1", source: "RHOA", target: "RAF1", weight: 1 } },
    { data: { id: "RHOA-RAP1A", source: "RHOA", target: "RAP1A", weight: 1 } },
    { data: { id: "RHOA-NRAS", source: "RHOA", target: "NRAS", weight: 1 } },
    {
      data: { id: "AP2A2-MAPK1", source: "AP2A2", target: "MAPK1", weight: 1 },
    },
    {
      data: { id: "AP2A2-ARCN1", source: "AP2A2", target: "ARCN1", weight: 1 },
    },
    { data: { id: "AP2A2-EGFR", source: "AP2A2", target: "EGFR", weight: 1 } },
    {
      data: { id: "AP2A2-KIF4A", source: "AP2A2", target: "KIF4A", weight: 1 },
    },
    {
      data: { id: "RAB2A-MAPK1", source: "RAB2A", target: "MAPK1", weight: 1 },
    },
    {
      data: { id: "GTF2F2-BRF2", source: "GTF2F2", target: "BRF2", weight: 1 },
    },
    {
      data: {
        id: "GTF2F2-YEATS4",
        source: "GTF2F2",
        target: "YEATS4",
        weight: 1,
      },
    },
    {
      data: {
        id: "GTF2F2-METTL3",
        source: "GTF2F2",
        target: "METTL3",
        weight: 1,
      },
    },
    {
      data: { id: "GTF2F2-RBM5", source: "GTF2F2", target: "RBM5", weight: 1 },
    },
    {
      data: { id: "GTF2F2-YBX1", source: "GTF2F2", target: "YBX1", weight: 1 },
    },
    {
      data: { id: "EXOSC5-TDP2", source: "EXOSC5", target: "TDP2", weight: 1 },
    },
    { data: { id: "TLE5-MYC", source: "TLE5", target: "MYC", weight: 1 } },
    { data: { id: "TLE5-TLE1", source: "TLE5", target: "TLE1", weight: 1 } },
    {
      data: { id: "TLE5-CREBBP", source: "TLE5", target: "CREBBP", weight: 1 },
    },
    { data: { id: "TLE5-CCND1", source: "TLE5", target: "CCND1", weight: 1 } },
    { data: { id: "TLE1-CCND1", source: "TLE1", target: "CCND1", weight: 1 } },
    { data: { id: "TLE1-APC", source: "TLE1", target: "APC", weight: 1 } },
    {
      data: { id: "TLE1-CREBBP", source: "TLE1", target: "CREBBP", weight: 1 },
    },
    { data: { id: "TLE1-ASCL1", source: "TLE1", target: "ASCL1", weight: 1 } },
    { data: { id: "TLE1-MYC", source: "TLE1", target: "MYC", weight: 1 } },
    { data: { id: "SCCPDH-HGF", source: "SCCPDH", target: "HGF", weight: 1 } },
    {
      data: { id: "RIPK1-NFKB1", source: "RIPK1", target: "NFKB1", weight: 1 },
    },
    {
      data: {
        id: "RIPK1-MAP2K4",
        source: "RIPK1",
        target: "MAP2K4",
        weight: 1,
      },
    },
    {
      data: { id: "RIPK1-TRAF6", source: "RIPK1", target: "TRAF6", weight: 1 },
    },
    {
      data: { id: "RIPK1-PRKCI", source: "RIPK1", target: "PRKCI", weight: 1 },
    },
    { data: { id: "RIPK1-CAV1", source: "RIPK1", target: "CAV1", weight: 1 } },
    { data: { id: "RIPK1-CYLD", source: "RIPK1", target: "CYLD", weight: 1 } },
    {
      data: { id: "HDAC2-NFKB1", source: "HDAC2", target: "NFKB1", weight: 1 },
    },
    { data: { id: "HDAC2-CDH1", source: "HDAC2", target: "CDH1", weight: 1 } },
    { data: { id: "HDAC2-RBL2", source: "HDAC2", target: "RBL2", weight: 1 } },
    { data: { id: "HDAC2-YY1", source: "HDAC2", target: "YY1", weight: 1 } },
    {
      data: {
        id: "HDAC2-CREBBP",
        source: "HDAC2",
        target: "CREBBP",
        weight: 1,
      },
    },
    { data: { id: "HDAC2-RB1", source: "HDAC2", target: "RB1", weight: 1 } },
    { data: { id: "HDAC2-TP53", source: "HDAC2", target: "TP53", weight: 1 } },
    {
      data: {
        id: "HDAC2-SETDB1",
        source: "HDAC2",
        target: "SETDB1",
        weight: 1,
      },
    },
    { data: { id: "HDAC2-EZH2", source: "HDAC2", target: "EZH2", weight: 1 } },
    {
      data: { id: "HDAC2-SIRT7", source: "HDAC2", target: "SIRT7", weight: 1 },
    },
    { data: { id: "HDAC2-TTF1", source: "HDAC2", target: "TTF1", weight: 1 } },
    {
      data: { id: "HDAC2-SIRT3", source: "HDAC2", target: "SIRT3", weight: 1 },
    },
    {
      data: { id: "HDAC2-SETD2", source: "HDAC2", target: "SETD2", weight: 1 },
    },
    { data: { id: "HDAC2-BAP1", source: "HDAC2", target: "BAP1", weight: 1 } },
    { data: { id: "ERC1-NFKB1", source: "ERC1", target: "NFKB1", weight: 1 } },
    { data: { id: "ERC1-CCND1", source: "ERC1", target: "CCND1", weight: 1 } },
    { data: { id: "ERC1-PRKCI", source: "ERC1", target: "PRKCI", weight: 1 } },
    { data: { id: "ERC1-TRAF6", source: "ERC1", target: "TRAF6", weight: 1 } },
    {
      data: { id: "MOV10-CCND1", source: "MOV10", target: "CCND1", weight: 1 },
    },
    {
      data: {
        id: "MOV10-CREBBP",
        source: "MOV10",
        target: "CREBBP",
        weight: 1,
      },
    },
    { data: { id: "MOV10-TP53", source: "MOV10", target: "TP53", weight: 1 } },
    { data: { id: "MOV10-ETS1", source: "MOV10", target: "ETS1", weight: 1 } },
    { data: { id: "MOV10-MYC", source: "MOV10", target: "MYC", weight: 1 } },
    { data: { id: "MOV10-PTEN", source: "MOV10", target: "PTEN", weight: 1 } },
    { data: { id: "CEP55-ECT2", source: "CEP55", target: "ECT2", weight: 1 } },
    {
      data: { id: "CEP55-FOXM1", source: "CEP55", target: "FOXM1", weight: 1 },
    },
    {
      data: { id: "CEP55-PTTG1", source: "CEP55", target: "PTTG1", weight: 1 },
    },
    {
      data: { id: "CEP55-UBE2C", source: "CEP55", target: "UBE2C", weight: 1 },
    },
    {
      data: { id: "CEP55-KIF4A", source: "CEP55", target: "KIF4A", weight: 1 },
    },
    { data: { id: "CPSF3-RBM5", source: "CPSF3", target: "RBM5", weight: 1 } },
    { data: { id: "CPSF3-YBX1", source: "CPSF3", target: "YBX1", weight: 1 } },
    {
      data: {
        id: "PDZD11-KIF4A",
        source: "PDZD11",
        target: "KIF4A",
        weight: 1,
      },
    },
    {
      data: {
        id: "TCF12-TWIST1",
        source: "TCF12",
        target: "TWIST1",
        weight: 1,
      },
    },
    {
      data: { id: "TCF12-ASCL1", source: "TCF12", target: "ASCL1", weight: 1 },
    },
    { data: { id: "GDF15-TP53", source: "GDF15", target: "TP53", weight: 1 } },
    { data: { id: "F2RL1-GRP", source: "F2RL1", target: "GRP", weight: 1 } },
    {
      data: {
        id: "F2RL1-PIK3CA",
        source: "F2RL1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    { data: { id: "TLE3-APC", source: "TLE3", target: "APC", weight: 1 } },
    {
      data: { id: "TLE3-CREBBP", source: "TLE3", target: "CREBBP", weight: 1 },
    },
    { data: { id: "TLE3-TLE1", source: "TLE3", target: "TLE1", weight: 1 } },
    { data: { id: "REEP5-APC", source: "REEP5", target: "APC", weight: 1 } },
    {
      data: {
        id: "GORASP1-PSMA6",
        source: "GORASP1",
        target: "PSMA6",
        weight: 1,
      },
    },
    {
      data: {
        id: "GORASP1-ARCN1",
        source: "GORASP1",
        target: "ARCN1",
        weight: 1,
      },
    },
    { data: { id: "DNMT1-CDH1", source: "DNMT1", target: "CDH1", weight: 1 } },
    {
      data: { id: "DNMT1-STAT3", source: "DNMT1", target: "STAT3", weight: 1 },
    },
    {
      data: {
        id: "DNMT1-DNMT3A",
        source: "DNMT1",
        target: "DNMT3A",
        weight: 1,
      },
    },
    { data: { id: "DNMT1-RB1", source: "DNMT1", target: "RB1", weight: 1 } },
    { data: { id: "DNMT1-TP53", source: "DNMT1", target: "TP53", weight: 1 } },
    { data: { id: "DNMT1-AKT1", source: "DNMT1", target: "AKT1", weight: 1 } },
    { data: { id: "DNMT1-EZH2", source: "DNMT1", target: "EZH2", weight: 1 } },
    { data: { id: "DNMT1-TTF1", source: "DNMT1", target: "TTF1", weight: 1 } },
    { data: { id: "DNMT1-PCNA", source: "DNMT1", target: "PCNA", weight: 1 } },
    { data: { id: "RAB7A-CDH1", source: "RAB7A", target: "CDH1", weight: 1 } },
    {
      data: { id: "RAB7A-KIF5B", source: "RAB7A", target: "KIF5B", weight: 1 },
    },
    {
      data: { id: "RAB7A-KIF4A", source: "RAB7A", target: "KIF4A", weight: 1 },
    },
    {
      data: { id: "RAB7A-RAP1A", source: "RAB7A", target: "RAP1A", weight: 1 },
    },
    {
      data: {
        id: "PTGES2-CREBBP",
        source: "PTGES2",
        target: "CREBBP",
        weight: 1,
      },
    },
    {
      data: {
        id: "PTGES2-PTGS2",
        source: "PTGES2",
        target: "PTGS2",
        weight: 1,
      },
    },
    {
      data: {
        id: "SNIP1-CREBBP",
        source: "SNIP1",
        target: "CREBBP",
        weight: 1,
      },
    },
    {
      data: {
        id: "ACADM-CREBBP",
        source: "ACADM",
        target: "CREBBP",
        weight: 1,
      },
    },
    { data: { id: "FBN2-PDCD1", source: "FBN2", target: "PDCD1", weight: 1 } },
    {
      data: {
        id: "CSNK2A2-TP53",
        source: "CSNK2A2",
        target: "TP53",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-AKT1",
        source: "SLC9A3R1",
        target: "AKT1",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-PTEN",
        source: "SLC9A3R1",
        target: "PTEN",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-EGFR",
        source: "SLC9A3R1",
        target: "EGFR",
        weight: 1,
      },
    },
    { data: { id: "BRD4-MYC", source: "BRD4", target: "MYC", weight: 1 } },
    {
      data: {
        id: "ITGB1-PIK3CA",
        source: "ITGB1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    { data: { id: "ITGB1-EGFR", source: "ITGB1", target: "EGFR", weight: 1 } },
    { data: { id: "ITGB1-CRKL", source: "ITGB1", target: "CRKL", weight: 1 } },
    { data: { id: "ITGB1-MYC", source: "ITGB1", target: "MYC", weight: 1 } },
    {
      data: { id: "ITGB1-TGFBI", source: "ITGB1", target: "TGFBI", weight: 1 },
    },
    { data: { id: "ITGB1-PTEN", source: "ITGB1", target: "PTEN", weight: 1 } },
    { data: { id: "ITGB1-CAV1", source: "ITGB1", target: "CAV1", weight: 1 } },
    { data: { id: "ITGB1-SRC", source: "ITGB1", target: "SRC", weight: 1 } },
    {
      data: { id: "ITGB1-RAP1A", source: "ITGB1", target: "RAP1A", weight: 1 },
    },
    {
      data: {
        id: "GOLGB1-ARCN1",
        source: "GOLGB1",
        target: "ARCN1",
        weight: 1,
      },
    },
    {
      data: { id: "RAB1A-ARCN1", source: "RAB1A", target: "ARCN1", weight: 1 },
    },
    {
      data: { id: "RAB1A-KIF5B", source: "RAB1A", target: "KIF5B", weight: 1 },
    },
    {
      data: { id: "RAB1A-KIF4A", source: "RAB1A", target: "KIF4A", weight: 1 },
    },
    {
      data: {
        id: "PTPN13-STAT3",
        source: "PTPN13",
        target: "STAT3",
        weight: 1,
      },
    },
    { data: { id: "PTPN13-SRC", source: "PTPN13", target: "SRC", weight: 1 } },
    {
      data: {
        id: "MAT2B-DNMT3A",
        source: "MAT2B",
        target: "DNMT3A",
        weight: 1,
      },
    },
    {
      data: { id: "MAT2B-PTRH2", source: "MAT2B", target: "PTRH2", weight: 1 },
    },
    { data: { id: "POLA2-PCNA", source: "POLA2", target: "PCNA", weight: 1 } },
    { data: { id: "POLA2-RB1", source: "POLA2", target: "RB1", weight: 1 } },
    { data: { id: "IDE-PTRH2", source: "IDE", target: "PTRH2", weight: 1 } },
    { data: { id: "PRIM1-RB1", source: "PRIM1", target: "RB1", weight: 1 } },
    { data: { id: "PRIM1-PCNA", source: "PRIM1", target: "PCNA", weight: 1 } },
    { data: { id: "POLA1-RB1", source: "POLA1", target: "RB1", weight: 1 } },
    { data: { id: "POLA1-TP53", source: "POLA1", target: "TP53", weight: 1 } },
    { data: { id: "POLA1-PCNA", source: "POLA1", target: "PCNA", weight: 1 } },
    { data: { id: "CRTC3-ATF3", source: "CRTC3", target: "ATF3", weight: 1 } },
    { data: { id: "GPX1-TP53", source: "GPX1", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-TP53", source: "DNA2", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-PCNA", source: "DNA2", target: "PCNA", weight: 1 } },
    {
      data: { id: "CSNK2B-TP53", source: "CSNK2B", target: "TP53", weight: 1 },
    },
    {
      data: { id: "CSNK2B-EZH2", source: "CSNK2B", target: "EZH2", weight: 1 },
    },
    {
      data: { id: "ECSIT-TRAF6", source: "ECSIT", target: "TRAF6", weight: 1 },
    },
    {
      data: {
        id: "PLOD2-SETDB1",
        source: "PLOD2",
        target: "SETDB1",
        weight: 1,
      },
    },
    {
      data: { id: "PLOD2-SETD2", source: "PLOD2", target: "SETD2", weight: 1 },
    },
    { data: { id: "SAV1-LIMD1", source: "SAV1", target: "LIMD1", weight: 1 } },
    { data: { id: "SAV1-YAP1", source: "SAV1", target: "YAP1", weight: 1 } },
    { data: { id: "SAV1-LATS2", source: "SAV1", target: "LATS2", weight: 1 } },
    { data: { id: "RAB5C-EGFR", source: "RAB5C", target: "EGFR", weight: 1 } },
    {
      data: { id: "RAB5C-RAP1A", source: "RAB5C", target: "RAP1A", weight: 1 },
    },
    { data: { id: "STK4-YAP1", source: "STK4", target: "YAP1", weight: 1 } },
    {
      data: { id: "STK4-RASSF1", source: "STK4", target: "RASSF1", weight: 1 },
    },
    { data: { id: "STK4-LATS2", source: "STK4", target: "LATS2", weight: 1 } },
    { data: { id: "STK3-YAP1", source: "STK3", target: "YAP1", weight: 1 } },
    {
      data: { id: "STK3-RASSF1", source: "STK3", target: "RASSF1", weight: 1 },
    },
    { data: { id: "STK3-LATS2", source: "STK3", target: "LATS2", weight: 1 } },
    {
      data: {
        id: "TOMM70-PTRH2",
        source: "TOMM70",
        target: "PTRH2",
        weight: 1,
      },
    },
    {
      data: { id: "TMED5-WNT7A", source: "TMED5", target: "WNT7A", weight: 1 },
    },
    { data: { id: "RAB14-HPGD", source: "RAB14", target: "HPGD", weight: 1 } },
    {
      data: { id: "NDUFAF2-MYC", source: "NDUFAF2", target: "MYC", weight: 1 },
    },
    { data: { id: "SLU7-MYB", source: "SLU7", target: "MYB", weight: 1 } },
    { data: { id: "SLU7-RBM5", source: "SLU7", target: "RBM5", weight: 1 } },
    { data: { id: "SLU7-YBX1", source: "SLU7", target: "YBX1", weight: 1 } },
    { data: { id: "SLU7-TTF1", source: "SLU7", target: "TTF1", weight: 1 } },
    { data: { id: "NUP62-BCL2", source: "NUP62", target: "BCL2", weight: 1 } },
    { data: { id: "IBTK-SYK", source: "IBTK", target: "SYK", weight: 1 } },
    {
      data: { id: "UBAP2L-EZH2", source: "UBAP2L", target: "EZH2", weight: 1 },
    },
    {
      data: { id: "UBAP2L-BAP1", source: "UBAP2L", target: "BAP1", weight: 1 },
    },
    { data: { id: "TBK1-TRAF6", source: "TBK1", target: "TRAF6", weight: 1 } },
    {
      data: {
        id: "SNRNP48-YBX1",
        source: "SNRNP48",
        target: "YBX1",
        weight: 1,
      },
    },
    {
      data: { id: "CENPF-FOXM1", source: "CENPF", target: "FOXM1", weight: 1 },
    },
    {
      data: { id: "CENPF-PTTG1", source: "CENPF", target: "PTTG1", weight: 1 },
    },
    {
      data: { id: "CENPF-UBE2C", source: "CENPF", target: "UBE2C", weight: 1 },
    },
    {
      data: { id: "CENPF-KIF4A", source: "CENPF", target: "KIF4A", weight: 1 },
    },
    { data: { id: "CWC27-RBM5", source: "CWC27", target: "RBM5", weight: 1 } },
    { data: { id: "CWC27-YBX1", source: "CWC27", target: "YBX1", weight: 1 } },
    { data: { id: "PMPCA-PTEN", source: "PMPCA", target: "PTEN", weight: 1 } },
    {
      data: { id: "EXOSC2-TDP2", source: "EXOSC2", target: "TDP2", weight: 1 },
    },
    { data: { id: "CSDE1-YBX1", source: "CSDE1", target: "YBX1", weight: 1 } },
    { data: { id: "CSDE1-MYC", source: "CSDE1", target: "MYC", weight: 1 } },
    { data: { id: "RNPC3-YBX1", source: "RNPC3", target: "YBX1", weight: 1 } },
    {
      data: { id: "HS6ST2-GPC5", source: "HS6ST2", target: "GPC5", weight: 1 },
    },
    {
      data: { id: "EXOSC8-TDP2", source: "EXOSC8", target: "TDP2", weight: 1 },
    },
    { data: { id: "TYK2-MAPK1", source: "TYK2", target: "MAPK1", weight: 1 } },
    { data: { id: "TYK2-NFKB1", source: "TYK2", target: "NFKB1", weight: 1 } },
    { data: { id: "TYK2-IL6", source: "TYK2", target: "IL6", weight: 1 } },
    {
      data: { id: "TYK2-PIK3CA", source: "TYK2", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "TYK2-STAT3", source: "TYK2", target: "STAT3", weight: 1 } },
    { data: { id: "TYK2-FOS", source: "TYK2", target: "FOS", weight: 1 } },
    { data: { id: "HLA-G-EGR1", source: "HLA-G", target: "EGR1", weight: 1 } },
    { data: { id: "IFNAR2-IL6", source: "IFNAR2", target: "IL6", weight: 1 } },
    {
      data: {
        id: "NOTCH4-CREBBP",
        source: "NOTCH4",
        target: "CREBBP",
        weight: 1,
      },
    },
    {
      data: {
        id: "NOTCH4-ERBB2",
        source: "NOTCH4",
        target: "ERBB2",
        weight: 1,
      },
    },
    {
      data: { id: "NOTCH4-EGFR", source: "NOTCH4", target: "EGFR", weight: 1 },
    },
    { data: { id: "MARK3-RAF1", source: "MARK3", target: "RAF1", weight: 1 } },
    { data: { id: "MARK3-KRAS", source: "MARK3", target: "KRAS", weight: 1 } },
    {
      data: { id: "MARK3-RAP1A", source: "MARK3", target: "RAP1A", weight: 1 },
    },
    {
      data: { id: "MARK3-MARK2", source: "MARK3", target: "MARK2", weight: 1 },
    },
    { data: { id: "MARK3-NRAS", source: "MARK3", target: "NRAS", weight: 1 } },
    {
      data: { id: "MARK3-MAPK1", source: "MARK3", target: "MAPK1", weight: 1 },
    },
    {
      data: { id: "RAB8A-RAP1A", source: "RAB8A", target: "RAP1A", weight: 1 },
    },
    {
      data: {
        id: "PRKACA-CREBBP",
        source: "PRKACA",
        target: "CREBBP",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-ERBB3",
        source: "PRKACA",
        target: "ERBB3",
        weight: 1,
      },
    },
    {
      data: { id: "PRKACA-SOX9", source: "PRKACA", target: "SOX9", weight: 1 },
    },
    {
      data: { id: "PRKACA-RAF1", source: "PRKACA", target: "RAF1", weight: 1 },
    },
    {
      data: {
        id: "PRKACA-ERBB2",
        source: "PRKACA",
        target: "ERBB2",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-NFKB1",
        source: "PRKACA",
        target: "NFKB1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-PTGDR",
        source: "PRKACA",
        target: "PTGDR",
        weight: 1,
      },
    },
    { data: { id: "PRKACA-RET", source: "PRKACA", target: "RET", weight: 1 } },
    {
      data: {
        id: "PRKACA-MAPK1",
        source: "PRKACA",
        target: "MAPK1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-RAP1A",
        source: "PRKACA",
        target: "RAP1A",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-STK11",
        source: "PRKACA",
        target: "STK11",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CCND1",
        source: "PRKACA",
        target: "CCND1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CACNA2D3",
        source: "PRKACA",
        target: "CACNA2D3",
        weight: 1,
      },
    },
    {
      data: { id: "PRKACA-TTF1", source: "PRKACA", target: "TTF1", weight: 1 },
    },
    {
      data: { id: "MARK2-PRKCI", source: "MARK2", target: "PRKCI", weight: 1 },
    },
    {
      data: { id: "MARK2-STK11", source: "MARK2", target: "STK11", weight: 1 },
    },
    { data: { id: "MIB1-MARK2", source: "MIB1", target: "MARK2", weight: 1 } },
    { data: { id: "AKAP9-KRAS", source: "AKAP9", target: "KRAS", weight: 1 } },
    { data: { id: "AKAP9-NRAS", source: "AKAP9", target: "NRAS", weight: 1 } },
    {
      data: { id: "MARK1-MARK2", source: "MARK1", target: "MARK2", weight: 1 },
    },
    { data: { id: "RALA-NRAS", source: "RALA", target: "NRAS", weight: 1 } },
    { data: { id: "RALA-SRC", source: "RALA", target: "SRC", weight: 1 } },
    { data: { id: "RALA-KRAS", source: "RALA", target: "KRAS", weight: 1 } },
  ],
};

export const net_testis = {
  nodes: [
    {
      data: { id: "RHOA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -460.03131702441 },
    },
    {
      data: { id: "CSDE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -319.1632776081 },
    },
    {
      data: { id: "TLE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -107.86121848373 },
    },
    {
      data: { id: "PMPCA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 155.545121833743, y: -3.77238293813014 },
    },
    {
      data: { id: "STK4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -78.8878034405384, y: -292.486530633447 },
    },
    {
      data: {
        id: "RASSF1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: 105.09899225579, y: -325.987679549376 },
    },
    {
      data: { id: "STK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -78.8878034405384, y: -375.839860268971 },
    },
    {
      data: { id: "ITGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 155.545121833743, y: -67.189506509663 },
    },
    {
      data: { id: "NDUFAF2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -389.597297316248 },
    },
    {
      data: {
        id: "KIT",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 43.08869,
      },
      position: { x: 258.227841083858, y: 284.675105412383 },
    },
    {
      data: { id: "RNF41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 82.7105143983039, y: 282.908261447799 },
    },
    {
      data: { id: "CSNK2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 326.315849344559 },
    },
    {
      data: { id: "MOV10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 155.545121833743, y: -130.606630081196 },
    },
    {
      data: { id: "DNA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 198.565976471193 },
    },
    {
      data: { id: "GPX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 134.691040034511 },
    },
    {
      data: { id: "POLA1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -406.751848969889, y: 28.3755449163656 },
    },
    {
      data: { id: "PRIM1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -406.751848969889, y: -87.6239702591238 },
    },
    {
      data: { id: "DNMT1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -406.751848969889, y: -29.6242126713791 },
    },
    {
      data: { id: "HDAC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -406.751848969889, y: 86.3753025041103 },
    },
    {
      data: {
        id: "RB1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -254.401645613545, y: -35.0353606472126 },
    },
    {
      data: { id: "POLA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -406.751848969889, y: -145.623727846868 },
    },
    {
      data: { id: "BRD4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -178.295238191848 },
    },
    {
      data: {
        id: "PTEN",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: 342.675896756877, y: -47.0613767800669 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: 155.545121833743, y: 59.6447406334027 },
    },
    {
      data: { id: "CSNK2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 262.440912907876 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -315.824058889785, y: 272.469833429875 },
    },
    {
      data: {
        id: "CCND2",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -141.541617253824, y: 319.361619645474 },
    },
    {
      data: { id: "ERC1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -315.824058889785, y: 354.774673156286 },
    },
    {
      data: { id: "GDF15", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 390.190785781241 },
    },
    {
      data: {
        id: "MYC",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -744.929798208466, y: -393.039163241978 },
    },
    {
      data: { id: "TLE5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -904.622888134231, y: -248.729257899996 },
    },
    {
      data: {
        id: "TP53",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -595.592476430292, y: 218.207372923708 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -750.821038172404, y: 70.8161035978283 },
    },
  ],

  edges: [
    { data: { id: "RHOA-MYC", source: "RHOA", target: "MYC", weight: 1 } },
    { data: { id: "CSDE1-MYC", source: "CSDE1", target: "MYC", weight: 1 } },
    { data: { id: "TLE1-MYC", source: "TLE1", target: "MYC", weight: 1 } },
    { data: { id: "PMPCA-PTEN", source: "PMPCA", target: "PTEN", weight: 1 } },
    {
      data: { id: "STK4-RASSF1", source: "STK4", target: "RASSF1", weight: 1 },
    },
    {
      data: { id: "STK3-RASSF1", source: "STK3", target: "RASSF1", weight: 1 },
    },
    { data: { id: "ITGB1-PTEN", source: "ITGB1", target: "PTEN", weight: 1 } },
    { data: { id: "ITGB1-MYC", source: "ITGB1", target: "MYC", weight: 1 } },
    {
      data: { id: "NDUFAF2-MYC", source: "NDUFAF2", target: "MYC", weight: 1 },
    },
    { data: { id: "RNF41-KIT", source: "RNF41", target: "KIT", weight: 1 } },
    {
      data: { id: "CSNK2B-TP53", source: "CSNK2B", target: "TP53", weight: 1 },
    },
    { data: { id: "MOV10-PTEN", source: "MOV10", target: "PTEN", weight: 1 } },
    { data: { id: "MOV10-MYC", source: "MOV10", target: "MYC", weight: 1 } },
    { data: { id: "MOV10-TP53", source: "MOV10", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-TP53", source: "DNA2", target: "TP53", weight: 1 } },
    { data: { id: "GPX1-TP53", source: "GPX1", target: "TP53", weight: 1 } },
    { data: { id: "POLA1-TP53", source: "POLA1", target: "TP53", weight: 1 } },
    { data: { id: "POLA1-RB1", source: "POLA1", target: "RB1", weight: 1 } },
    { data: { id: "PRIM1-RB1", source: "PRIM1", target: "RB1", weight: 1 } },
    { data: { id: "DNMT1-TP53", source: "DNMT1", target: "TP53", weight: 1 } },
    { data: { id: "DNMT1-RB1", source: "DNMT1", target: "RB1", weight: 1 } },
    { data: { id: "HDAC2-TP53", source: "HDAC2", target: "TP53", weight: 1 } },
    { data: { id: "HDAC2-RB1", source: "HDAC2", target: "RB1", weight: 1 } },
    { data: { id: "POLA2-RB1", source: "POLA2", target: "RB1", weight: 1 } },
    { data: { id: "BRD4-MYC", source: "BRD4", target: "MYC", weight: 1 } },
    {
      data: {
        id: "SLC9A3R1-PTEN",
        source: "SLC9A3R1",
        target: "PTEN",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-TP53",
        source: "CSNK2A2",
        target: "TP53",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CCND2",
        source: "PRKACA",
        target: "CCND2",
        weight: 1,
      },
    },
    { data: { id: "ERC1-CCND2", source: "ERC1", target: "CCND2", weight: 1 } },
    { data: { id: "GDF15-TP53", source: "GDF15", target: "TP53", weight: 1 } },
    { data: { id: "TLE5-MYC", source: "TLE5", target: "MYC", weight: 1 } },
    { data: { id: "PSMD8-TP53", source: "PSMD8", target: "TP53", weight: 1 } },
  ],
};

export const net_colon = {
  nodes: [
    {
      data: { id: "NOTCH4", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -826.326831032752, y: 254.938922949138 },
    },
    {
      data: { id: "TYK2", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: 961.367829320992, y: -662.831772580828 },
    },
    {
      data: {
        id: "DCC",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -987.917455216871, y: 146.712627519837 },
    },
    {
      data: { id: "CSDE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -530.613102479138, y: -15.5744509532808 },
    },
    {
      data: {
        id: "HCAR2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 234.075576128329, y: -47.6782051542173 },
    },
    {
      data: { id: "MARK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 162.244951564119, y: -769.932532014577 },
    },
    {
      data: {
        id: "E2F2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -293.157588858472, y: -635.232897036348 },
    },
    {
      data: { id: "STK4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -79.9119066815915, y: 289.291143273238 },
    },
    {
      data: {
        id: "RASSF1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 33.9985010105931, y: 231.933547606718 },
    },
    {
      data: { id: "STK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -76.1831872075572, y: 192.836062572505 },
    },
    {
      data: { id: "PTGES2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 719.292008341728, y: -564.775542573896 },
    },
    {
      data: { id: "NUP214", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -643.280642425241, y: -326.335603490372 },
    },
    {
      data: {
        id: "RET",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -987.917455216871, y: 266.482497626022 },
    },
    {
      data: { id: "GNG5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 88.8502747011642, y: -46.6211993416874 },
    },
    {
      data: {
        id: "PTGDR",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -1007.72223828918, y: -316.594708864169 },
    },
    {
      data: {
        id: "ATOH1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 681.402908679311, y: 177.450814711457 },
    },
    {
      data: { id: "TCF12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 635.262519101564, y: 278.824094747633 },
    },
    {
      data: { id: "GORASP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 703.368879821079, y: -229.397307305427 },
    },
    {
      data: { id: "GOLGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 703.368879821079, y: -292.973884669523 },
    },
    {
      data: { id: "RAB1A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 703.368879821079, y: -356.55046203362 },
    },
    {
      data: {
        id: "MET",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -987.917455216871, y: 29.7986641236471 },
    },
    {
      data: {
        id: "MYB",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 552.089469862704, y: 173.059830354442 },
    },
    {
      data: { id: "SLU7", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 505.035137567242, y: 276.535369323308 },
    },
    {
      data: {
        id: "CASR",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 234.075576128329, y: 48.9791465832448 },
    },
    {
      data: { id: "F2RL1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 88.8502747011642, y: 37.4087409437592 },
    },
    {
      data: { id: "NDUFAF2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -530.613102479138, y: 125.885352100508 },
    },
    {
      data: {
        id: "HPGD",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 41.60168,
      },
      position: { x: 403.016601439459, y: 166.473353818877 },
    },
    {
      data: { id: "RAB14", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 333.610698395593, y: 274.246643899012 },
    },
    {
      data: { id: "SNIP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -643.280642425241, y: -179.105142369766 },
    },
    {
      data: {
        id: "ALOX15",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -293.157588858472, y: -807.169882331151 },
    },
    {
      data: {
        id: "TMED3",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 831.953969258122, y: -180.169817040616 },
    },
    {
      data: {
        id: "NTRK1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 41.60168,
      },
      position: { x: 831.953969258122, y: -274.23094992995 },
    },
    {
      data: { id: "ITGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -61.0630988929849, y: -405.854645807542 },
    },
    {
      data: { id: "ARF6", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1174.87682385561, y: 194.095682366609 },
    },
    {
      data: { id: "AP2M1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 703.368879821079, y: -165.820729941331 },
    },
    {
      data: { id: "RAB5C", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1174.87682385561, y: 62.6110473271739 },
    },
    {
      data: { id: "AP2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 703.368879821079, y: -102.244152577234 },
    },
    {
      data: { id: "RNF41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1174.87682385561, y: 259.837999886327 },
    },
    {
      data: {
        id: "ERBB2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -987.917455216871, y: 205.169609217975 },
    },
    {
      data: { id: "CSNK2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -799.082447282873 },
    },
    {
      data: { id: "POLA1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -685.637117506432 },
    },
    {
      data: { id: "DNA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -742.359782394682 },
    },
    {
      data: { id: "GPX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -912.527777059256 },
    },
    {
      data: {
        id: "SMAD4",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -516.618563567819, y: -256.055391088028 },
    },
    {
      data: { id: "INHBE", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -643.280642425241, y: -252.720372930069 },
    },
    {
      data: { id: "RAB7A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -684.399245153385 },
    },
    {
      data: { id: "DNMT1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -628.914452618269 },
    },
    {
      data: {
        id: "STAT3",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 825.840209037537, y: -719.948295183693 },
    },
    {
      data: { id: "PTPN13", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 719.292008341728, y: -642.592733214224 },
    },
    {
      data: { id: "BRD4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -530.613102479138, y: 55.1554505736284 },
    },
    {
      data: {
        id: "INPP4B",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 62.9891117128527, y: -233.913645693719 },
    },
    {
      data: { id: "PMPCA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -61.0630988929849, y: -248.69421679945 },
    },
    {
      data: {
        id: "EGFR",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 48.20285,
      },
      position: { x: -987.917455216871, y: 88.2556458217564 },
    },
    {
      data: {
        id: "PTEN",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 62.9891117128527, y: -409.676594426366 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: -61.0630988929849, y: -327.274431303496 },
    },
    {
      data: { id: "CSNK2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -572.191787730049 },
    },
    {
      data: {
        id: "MARK2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 322.51738425079, y: -761.356272740003 },
    },
    {
      data: { id: "MIB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 162.244951564119, y: -839.197719120526 },
    },
    {
      data: { id: "REEP5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -305.753043861478 },
    },
    {
      data: { id: "MARK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 162.244951564119, y: -700.667344908656 },
    },
    {
      data: { id: "AKAP9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 162.244951564119, y: -631.402157802648 },
    },
    {
      data: { id: "GDF15", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -855.805112171094 },
    },
    {
      data: { id: "HDAC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -558.183844722662 },
    },
    {
      data: { id: "TLE3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -242.645343646058 },
    },
    {
      data: {
        id: "BCL9",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1007.72223828918, y: -387.621042461948 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -431.968444292143 },
    },
    {
      data: { id: "MOV10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -470.607925650537, y: -515.469122841828 },
    },
    {
      data: { id: "RHOA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1174.87682385561, y: 128.353364846891 },
    },
    {
      data: { id: "TLE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -368.860744076694 },
    },
    {
      data: { id: "ERC1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -747.506945368688 },
    },
    {
      data: {
        id: "CTNNB1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 49.32424,
      },
      position: { x: -1007.72223828918, y: -529.673709657595 },
    },
    {
      data: {
        id: "MYC",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 79.58114,
      },
      position: { x: -391.353112692651, y: 53.1991591068126 },
    },
    {
      data: { id: "TLE5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -810.614645584021 },
    },
    {
      data: {
        id: "SALL4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 839.257745816615, y: 181.841799068442 },
    },
    {
      data: { id: "NSD2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 808.975683697509, y: 285.690271020433 },
    },
    {
      data: {
        id: "CDK8",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 43.08869,
      },
      position: { x: -1007.72223828918, y: -671.726376853388 },
    },
    {
      data: { id: "RBX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -495.076144507446 },
    },
    {
      data: {
        id: "PTGS2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 827.577742630914, y: -638.728388252167 },
    },
    {
      data: {
        id: "FOS",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 827.577742630914, y: -565.974063308874 },
    },
    {
      data: { id: "HMOX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 719.292008341728, y: -720.409923854552 },
    },
    {
      data: {
        id: "CDKN1A",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -1007.72223828918, y: -742.752710451255 },
    },
    {
      data: {
        id: "APC",
        oncg: 0,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 81.6331,
      },
      position: { x: -1007.72223828918, y: -458.647376059816 },
    },
    {
      data: {
        id: "TP53",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 67.23951,
      },
      position: { x: -293.157588858472, y: -721.201389683749 },
    },
    {
      data: {
        id: "CCND1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -1007.72223828918, y: -600.70004325555 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1216.20957992703, y: -621.291544937994 },
    },
    {
      data: {
        id: "SRC",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 62.9891117128527, y: -321.795120060043 },
    },
    {
      data: {
        id: "KRAS",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 97.25888,
      },
      position: { x: 322.51738425079, y: -660.566366958261 },
    },
    {
      data: { id: "RALA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 162.244951564119, y: -562.136970696756 },
    },
  ],

  edges: [
    {
      data: { id: "NOTCH4-EGFR", source: "NOTCH4", target: "EGFR", weight: 1 },
    },
    {
      data: {
        id: "NOTCH4-ERBB2",
        source: "NOTCH4",
        target: "ERBB2",
        weight: 1,
      },
    },
    { data: { id: "TYK2-FOS", source: "TYK2", target: "FOS", weight: 1 } },
    { data: { id: "TYK2-STAT3", source: "TYK2", target: "STAT3", weight: 1 } },
    { data: { id: "CSDE1-MYC", source: "CSDE1", target: "MYC", weight: 1 } },
    {
      data: { id: "MARK1-MARK2", source: "MARK1", target: "MARK2", weight: 1 },
    },
    {
      data: { id: "STK4-RASSF1", source: "STK4", target: "RASSF1", weight: 1 },
    },
    {
      data: { id: "STK3-RASSF1", source: "STK3", target: "RASSF1", weight: 1 },
    },
    {
      data: {
        id: "PTGES2-PTGS2",
        source: "PTGES2",
        target: "PTGS2",
        weight: 1,
      },
    },
    {
      data: {
        id: "NUP214-SMAD4",
        source: "NUP214",
        target: "SMAD4",
        weight: 1,
      },
    },
    { data: { id: "GNG5-HCAR2", source: "GNG5", target: "HCAR2", weight: 1 } },
    { data: { id: "GNG5-CASR", source: "GNG5", target: "CASR", weight: 1 } },
    { data: { id: "GNG5-PTGDR", source: "GNG5", target: "PTGDR", weight: 1 } },
    {
      data: { id: "TCF12-ATOH1", source: "TCF12", target: "ATOH1", weight: 1 },
    },
    {
      data: {
        id: "GORASP1-TMED3",
        source: "GORASP1",
        target: "TMED3",
        weight: 1,
      },
    },
    {
      data: {
        id: "GOLGB1-TMED3",
        source: "GOLGB1",
        target: "TMED3",
        weight: 1,
      },
    },
    {
      data: { id: "RAB1A-TMED3", source: "RAB1A", target: "TMED3", weight: 1 },
    },
    { data: { id: "SLU7-MYB", source: "SLU7", target: "MYB", weight: 1 } },
    { data: { id: "F2RL1-CASR", source: "F2RL1", target: "CASR", weight: 1 } },
    {
      data: { id: "NDUFAF2-MYC", source: "NDUFAF2", target: "MYC", weight: 1 },
    },
    { data: { id: "RAB14-HPGD", source: "RAB14", target: "HPGD", weight: 1 } },
    {
      data: { id: "SNIP1-SMAD4", source: "SNIP1", target: "SMAD4", weight: 1 },
    },
    { data: { id: "ITGB1-SRC", source: "ITGB1", target: "SRC", weight: 1 } },
    { data: { id: "ITGB1-PTEN", source: "ITGB1", target: "PTEN", weight: 1 } },
    { data: { id: "ITGB1-MYC", source: "ITGB1", target: "MYC", weight: 1 } },
    { data: { id: "ITGB1-EGFR", source: "ITGB1", target: "EGFR", weight: 1 } },
    { data: { id: "ARF6-MET", source: "ARF6", target: "MET", weight: 1 } },
    { data: { id: "ARF6-SRC", source: "ARF6", target: "SRC", weight: 1 } },
    { data: { id: "ARF6-EGFR", source: "ARF6", target: "EGFR", weight: 1 } },
    {
      data: { id: "AP2M1-TMED3", source: "AP2M1", target: "TMED3", weight: 1 },
    },
    {
      data: { id: "AP2M1-NTRK1", source: "AP2M1", target: "NTRK1", weight: 1 },
    },
    { data: { id: "AP2M1-EGFR", source: "AP2M1", target: "EGFR", weight: 1 } },
    { data: { id: "RAB5C-EGFR", source: "RAB5C", target: "EGFR", weight: 1 } },
    {
      data: { id: "AP2A2-NTRK1", source: "AP2A2", target: "NTRK1", weight: 1 },
    },
    {
      data: { id: "AP2A2-TMED3", source: "AP2A2", target: "TMED3", weight: 1 },
    },
    { data: { id: "AP2A2-EGFR", source: "AP2A2", target: "EGFR", weight: 1 } },
    {
      data: { id: "RNF41-NTRK1", source: "RNF41", target: "NTRK1", weight: 1 },
    },
    { data: { id: "RNF41-RET", source: "RNF41", target: "RET", weight: 1 } },
    { data: { id: "RNF41-MET", source: "RNF41", target: "MET", weight: 1 } },
    { data: { id: "RNF41-EGFR", source: "RNF41", target: "EGFR", weight: 1 } },
    {
      data: { id: "RNF41-ERBB2", source: "RNF41", target: "ERBB2", weight: 1 },
    },
    {
      data: { id: "CSNK2B-TP53", source: "CSNK2B", target: "TP53", weight: 1 },
    },
    { data: { id: "POLA1-TP53", source: "POLA1", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-TP53", source: "DNA2", target: "TP53", weight: 1 } },
    {
      data: { id: "GPX1-ALOX15", source: "GPX1", target: "ALOX15", weight: 1 },
    },
    { data: { id: "GPX1-TP53", source: "GPX1", target: "TP53", weight: 1 } },
    {
      data: { id: "INHBE-SMAD4", source: "INHBE", target: "SMAD4", weight: 1 },
    },
    {
      data: {
        id: "RAB7A-CTNNB1",
        source: "RAB7A",
        target: "CTNNB1",
        weight: 1,
      },
    },
    { data: { id: "DNMT1-E2F2", source: "DNMT1", target: "E2F2", weight: 1 } },
    { data: { id: "DNMT1-TP53", source: "DNMT1", target: "TP53", weight: 1 } },
    {
      data: { id: "DNMT1-STAT3", source: "DNMT1", target: "STAT3", weight: 1 },
    },
    { data: { id: "PTPN13-SRC", source: "PTPN13", target: "SRC", weight: 1 } },
    {
      data: {
        id: "PTPN13-STAT3",
        source: "PTPN13",
        target: "STAT3",
        weight: 1,
      },
    },
    { data: { id: "BRD4-MYC", source: "BRD4", target: "MYC", weight: 1 } },
    { data: { id: "PMPCA-PTEN", source: "PMPCA", target: "PTEN", weight: 1 } },
    {
      data: {
        id: "PMPCA-INPP4B",
        source: "PMPCA",
        target: "INPP4B",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-EGFR",
        source: "SLC9A3R1",
        target: "EGFR",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-PTEN",
        source: "SLC9A3R1",
        target: "PTEN",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-CTNNB1",
        source: "CSNK2A2",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-TP53",
        source: "CSNK2A2",
        target: "TP53",
        weight: 1,
      },
    },
    { data: { id: "MIB1-MARK2", source: "MIB1", target: "MARK2", weight: 1 } },
    { data: { id: "REEP5-APC", source: "REEP5", target: "APC", weight: 1 } },
    {
      data: { id: "MARK3-MARK2", source: "MARK3", target: "MARK2", weight: 1 },
    },
    { data: { id: "MARK3-KRAS", source: "MARK3", target: "KRAS", weight: 1 } },
    { data: { id: "AKAP9-KRAS", source: "AKAP9", target: "KRAS", weight: 1 } },
    { data: { id: "GDF15-TP53", source: "GDF15", target: "TP53", weight: 1 } },
    {
      data: {
        id: "HDAC2-CTNNB1",
        source: "HDAC2",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: { id: "HDAC2-SMAD4", source: "HDAC2", target: "SMAD4", weight: 1 },
    },
    { data: { id: "HDAC2-TP53", source: "HDAC2", target: "TP53", weight: 1 } },
    {
      data: {
        id: "HDAC2-CDKN1A",
        source: "HDAC2",
        target: "CDKN1A",
        weight: 1,
      },
    },
    {
      data: { id: "TLE3-CTNNB1", source: "TLE3", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "TLE3-APC", source: "TLE3", target: "APC", weight: 1 } },
    { data: { id: "TLE3-BCL9", source: "TLE3", target: "BCL9", weight: 1 } },
    { data: { id: "PRKACA-RET", source: "PRKACA", target: "RET", weight: 1 } },
    {
      data: {
        id: "PRKACA-CTNNB1",
        source: "PRKACA",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-PTGDR",
        source: "PRKACA",
        target: "PTGDR",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-ERBB2",
        source: "PRKACA",
        target: "ERBB2",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CDKN1A",
        source: "PRKACA",
        target: "CDKN1A",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CCND1",
        source: "PRKACA",
        target: "CCND1",
        weight: 1,
      },
    },
    { data: { id: "MOV10-PTEN", source: "MOV10", target: "PTEN", weight: 1 } },
    { data: { id: "MOV10-MYC", source: "MOV10", target: "MYC", weight: 1 } },
    { data: { id: "MOV10-E2F2", source: "MOV10", target: "E2F2", weight: 1 } },
    { data: { id: "MOV10-TP53", source: "MOV10", target: "TP53", weight: 1 } },
    {
      data: { id: "MOV10-CCND1", source: "MOV10", target: "CCND1", weight: 1 },
    },
    { data: { id: "RHOA-DCC", source: "RHOA", target: "DCC", weight: 1 } },
    { data: { id: "RHOA-MYC", source: "RHOA", target: "MYC", weight: 1 } },
    { data: { id: "RHOA-SRC", source: "RHOA", target: "SRC", weight: 1 } },
    {
      data: { id: "RHOA-CTNNB1", source: "RHOA", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "RHOA-MET", source: "RHOA", target: "MET", weight: 1 } },
    { data: { id: "RHOA-FOS", source: "RHOA", target: "FOS", weight: 1 } },
    { data: { id: "RHOA-EGFR", source: "RHOA", target: "EGFR", weight: 1 } },
    { data: { id: "RHOA-ERBB2", source: "RHOA", target: "ERBB2", weight: 1 } },
    {
      data: { id: "RHOA-CDKN1A", source: "RHOA", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "RHOA-CCND1", source: "RHOA", target: "CCND1", weight: 1 } },
    { data: { id: "TLE1-MYC", source: "TLE1", target: "MYC", weight: 1 } },
    {
      data: { id: "TLE1-CTNNB1", source: "TLE1", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "TLE1-SMAD4", source: "TLE1", target: "SMAD4", weight: 1 } },
    { data: { id: "TLE1-APC", source: "TLE1", target: "APC", weight: 1 } },
    { data: { id: "TLE1-BCL9", source: "TLE1", target: "BCL9", weight: 1 } },
    { data: { id: "TLE1-CCND1", source: "TLE1", target: "CCND1", weight: 1 } },
    {
      data: { id: "ERC1-CDKN1A", source: "ERC1", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "ERC1-CCND1", source: "ERC1", target: "CCND1", weight: 1 } },
    {
      data: { id: "TLE5-CTNNB1", source: "TLE5", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "TLE5-CCND1", source: "TLE5", target: "CCND1", weight: 1 } },
    { data: { id: "TLE5-MYC", source: "TLE5", target: "MYC", weight: 1 } },
    { data: { id: "NSD2-SALL4", source: "NSD2", target: "SALL4", weight: 1 } },
    {
      data: { id: "RBX1-CDKN1A", source: "RBX1", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "RBX1-APC", source: "RBX1", target: "APC", weight: 1 } },
    { data: { id: "RBX1-CDK8", source: "RBX1", target: "CDK8", weight: 1 } },
    {
      data: { id: "HMOX1-PTGS2", source: "HMOX1", target: "PTGS2", weight: 1 },
    },
    { data: { id: "HMOX1-FOS", source: "HMOX1", target: "FOS", weight: 1 } },
    {
      data: {
        id: "PSMD8-CDKN1A",
        source: "PSMD8",
        target: "CDKN1A",
        weight: 1,
      },
    },
    { data: { id: "PSMD8-APC", source: "PSMD8", target: "APC", weight: 1 } },
    { data: { id: "PSMD8-TP53", source: "PSMD8", target: "TP53", weight: 1 } },
    {
      data: { id: "PSMD8-CCND1", source: "PSMD8", target: "CCND1", weight: 1 },
    },
    { data: { id: "RALA-SRC", source: "RALA", target: "SRC", weight: 1 } },
    { data: { id: "RALA-KRAS", source: "RALA", target: "KRAS", weight: 1 } },
  ],
};

export const net_intestinal = {
  nodes: [
    {
      data: { id: "REEP5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.263488083166, y: -240.364964719875 },
    },
    {
      data: { id: "TLE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.263488083166, y: -84.8774908874624 },
    },
    {
      data: { id: "TLE3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.263488083166, y: -162.621227803669 },
    },
    {
      data: { id: "MARK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -230.708451723964, y: 74.2896968532586 },
    },
    {
      data: { id: "AKAP9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -230.708451723964, y: 155.22289944411 },
    },
    {
      data: { id: "RBX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.263488083166, y: -7.13375397125589 },
    },
    {
      data: {
        id: "APC",
        oncg: 0,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 276.676613485433, y: -155.315083408542 },
    },
    {
      data: {
        id: "KRAS",
        oncg: 0,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -70.6846533732052, y: 162.734793264694 },
    },
    {
      data: { id: "RALA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -230.708451723964, y: 236.156102034947 },
    },
    {
      data: { id: "PRKAR2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -231.213076062848 },
    },
    {
      data: { id: "AP2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -5.98150916200774 },
    },
    {
      data: { id: "RAB5C", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -174.905184337638 },
    },
    {
      data: { id: "PRKAR2A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -118.597292612428 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.263488083166, y: -318.108701636082 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: -621.369456142035, y: -400.136751238479 },
    },
    {
      data: { id: "ERLEC1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -62.2894008872179 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: 50.3263825632024 },
    },
    {
      data: { id: "OS9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -287.520967788059 },
    },
    {
      data: {
        id: "CFTR",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -483.433976224341, y: -138.265552803969 },
    },
    {
      data: { id: "AP2M1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -621.369456142035, y: -343.828859513269 },
    },
  ],

  edges: [
    { data: { id: "REEP5-APC", source: "REEP5", target: "APC", weight: 1 } },
    { data: { id: "TLE1-APC", source: "TLE1", target: "APC", weight: 1 } },
    { data: { id: "TLE3-APC", source: "TLE3", target: "APC", weight: 1 } },
    { data: { id: "MARK3-KRAS", source: "MARK3", target: "KRAS", weight: 1 } },
    { data: { id: "AKAP9-KRAS", source: "AKAP9", target: "KRAS", weight: 1 } },
    { data: { id: "RBX1-APC", source: "RBX1", target: "APC", weight: 1 } },
    { data: { id: "RALA-KRAS", source: "RALA", target: "KRAS", weight: 1 } },
    {
      data: {
        id: "PRKAR2B-CFTR",
        source: "PRKAR2B",
        target: "CFTR",
        weight: 1,
      },
    },
    { data: { id: "AP2A2-CFTR", source: "AP2A2", target: "CFTR", weight: 1 } },
    { data: { id: "RAB5C-CFTR", source: "RAB5C", target: "CFTR", weight: 1 } },
    {
      data: {
        id: "PRKAR2A-CFTR",
        source: "PRKAR2A",
        target: "CFTR",
        weight: 1,
      },
    },
    { data: { id: "PSMD8-APC", source: "PSMD8", target: "APC", weight: 1 } },
    { data: { id: "PSMD8-CFTR", source: "PSMD8", target: "CFTR", weight: 1 } },
    {
      data: {
        id: "SLC9A3R1-CFTR",
        source: "SLC9A3R1",
        target: "CFTR",
        weight: 1,
      },
    },
    {
      data: { id: "ERLEC1-CFTR", source: "ERLEC1", target: "CFTR", weight: 1 },
    },
    {
      data: { id: "PRKACA-CFTR", source: "PRKACA", target: "CFTR", weight: 1 },
    },
    { data: { id: "OS9-CFTR", source: "OS9", target: "CFTR", weight: 1 } },
    { data: { id: "AP2M1-CFTR", source: "AP2M1", target: "CFTR", weight: 1 } },
  ],
};

export const net_kidney = {
  nodes: [
    {
      data: { id: "NOTCH4", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -1059.28297674523, y: -717.587372567849 },
    },
    {
      data: { id: "SEPSECS", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 322.338956736567, y: -10.2203863237519 },
    },
    {
      data: { id: "CSDE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -641.98544065518, y: -846.559815389234 },
    },
    {
      data: { id: "PMPCA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -394.428912253652 },
    },
    {
      data: {
        id: "CXCR4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -53.5670177375176, y: 248.954401757052 },
    },
    {
      data: { id: "GNG5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -126.340247832768, y: 326.975924201565 },
    },
    {
      data: { id: "UBAP2L", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 212.397660203868 },
    },
    {
      data: { id: "PTPN13", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -507.685692027045 },
    },
    {
      data: { id: "STK4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -532.455727312728, y: 345.37159195359 },
    },
    {
      data: {
        id: "RASSF1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -406.829907447397, y: 284.450992520129 },
    },
    {
      data: { id: "STK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -532.455727312728, y: 242.179858926709 },
    },
    {
      data: {
        id: "KANK1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 41.60168,
      },
      position: { x: 450.678207545459, y: -58.3066024453966 },
    },
    {
      data: { id: "TLE3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -269.373324973713 },
    },
    {
      data: { id: "NUP214", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -6.40796775408996 },
    },
    {
      data: { id: "TLE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -335.114664278619 },
    },
    {
      data: {
        id: "RET",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -293.30793540926, y: -300.954973035919 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -400.856003583525 },
    },
    {
      data: {
        id: "METTL3",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 44.4796,
      },
      position: { x: 405.764272057939, y: 263.738180606758 },
    },
    {
      data: { id: "GTF2F2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 323.69964032444, y: 343.79383575278 },
    },
    {
      data: {
        id: "MET",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 60.73178,
      },
      position: { x: -1251.51134505899, y: -732.071119648179 },
    },
    {
      data: { id: "NDUFAF2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -641.98544065518, y: -774.896641756339 },
    },
    {
      data: { id: "SNIP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -137.890646363902 },
    },
    {
      data: {
        id: "SETD2",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 45.78857,
      },
      position: { x: -1046.24437030479, y: -91.9942159821882 },
    },
    {
      data: { id: "PLOD2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: -206.409716231537 },
    },
    {
      data: { id: "ITGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -564.314081913713 },
    },
    {
      data: { id: "ARF6", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -734.199251573862 },
    },
    {
      data: { id: "AP2M1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -904.084421233923 },
    },
    {
      data: { id: "RAB5C", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -847.456031347226 },
    },
    {
      data: { id: "AP2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -790.827641460559 },
    },
    {
      data: { id: "RHOA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -620.942471800439 },
    },
    {
      data: { id: "CSNK2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 2.99397198615054 },
    },
    {
      data: { id: "POLA1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 55.344894040558 },
    },
    {
      data: { id: "MOV10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -641.98544065518, y: -559.907120857653 },
    },
    {
      data: { id: "DNMT1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 160.046738149431 },
    },
    {
      data: { id: "HDAC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: -154.058794177101 },
    },
    {
      data: { id: "DNA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 264.748582258304 },
    },
    {
      data: { id: "GPX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: -101.707872122664 },
    },
    {
      data: {
        id: "SMAD4",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -293.30793540926, y: -124.580680352227 },
    },
    {
      data: { id: "INHBE", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -72.1493070589958 },
    },
    {
      data: { id: "RAB7A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -462.842157556442, y: -203.631985668807 },
    },
    {
      data: { id: "BRD4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -641.98544065518, y: -631.570294490548 },
    },
    {
      data: {
        id: "EGFR",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -1253.30787186566, y: -667.173089354105 },
    },
    {
      data: {
        id: "PTEN",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -1253.30787186566, y: -541.193147633227 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: -1441.42126254614, y: -677.570861687165 },
    },
    {
      data: { id: "CSNK2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: -258.760638285974 },
    },
    {
      data: {
        id: "WNT10A",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 168.366614678983, y: 257.809642144744 },
    },
    {
      data: { id: "TMED5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 100.135239356848, y: 329.960579341415 },
    },
    {
      data: { id: "RNF41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -358.060302784378 },
    },
    {
      data: { id: "ELOB", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -473.613723777353 },
    },
    {
      data: { id: "HECTD1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -820.273986756135 },
    },
    {
      data: { id: "LRRC41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -646.943855266759 },
    },
    {
      data: { id: "ELOC", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -589.167144770271 },
    },
    {
      data: { id: "TRIM32", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -531.390434273812 },
    },
    {
      data: { id: "HERC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -762.497276259705 },
    },
    {
      data: { id: "MARK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 322.338956736567, y: -185.37576061509 },
    },
    {
      data: { id: "AKAP9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 322.338956736567, y: -97.7980734693847 },
    },
    {
      data: { id: "GDF15", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: 107.695816094994 },
    },
    {
      data: { id: "FBXL12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -415.837013280866 },
    },
    {
      data: { id: "DCTPP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -877.414569499004, y: 341.778538340249 },
    },
    {
      data: {
        id: "NT5C1A",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -773.077592292721, y: 286.067866646133 },
    },
    {
      data: { id: "IMPDH2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -877.414569499004, y: 236.61062582603 },
    },
    {
      data: {
        id: "CTNNB1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: -293.30793540926, y: -212.767826694073 },
    },
    {
      data: {
        id: "MYC",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 59.24992,
      },
      position: { x: -514.142969925702, y: -716.414240540402 },
    },
    {
      data: { id: "TLE5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -641.98544065518, y: -703.233468123443 },
    },
    {
      data: {
        id: "VHL",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 112.7148,
      },
      position: { x: 298.172432130574, y: -662.231213489091 },
    },
    {
      data: {
        id: "HACE1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 298.172432130574, y: -535.638469879073 },
    },
    {
      data: { id: "RBX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 105.328366036107, y: -704.720565763217 },
    },
    {
      data: {
        id: "BAP1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1046.24437030479, y: 69.3352040358217 },
    },
    {
      data: {
        id: "TP53",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 48.20285,
      },
      position: { x: -1046.24437030479, y: -11.3295059731687 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1210.84019709702, y: -49.356950068286 },
    },
    {
      data: {
        id: "SRC",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1253.30787186566, y: -604.183118493666 },
    },
    {
      data: {
        id: "KRAS",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 43.08869,
      },
      position: { x: 450.678207545459, y: -137.129517352334 },
    },
    {
      data: { id: "RALA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1441.42126254614, y: -451.057302140349 },
    },
  ],

  edges: [
    {
      data: { id: "NOTCH4-EGFR", source: "NOTCH4", target: "EGFR", weight: 1 },
    },
    {
      data: {
        id: "SEPSECS-KANK1",
        source: "SEPSECS",
        target: "KANK1",
        weight: 1,
      },
    },
    { data: { id: "CSDE1-MYC", source: "CSDE1", target: "MYC", weight: 1 } },
    { data: { id: "PMPCA-PTEN", source: "PMPCA", target: "PTEN", weight: 1 } },
    { data: { id: "GNG5-CXCR4", source: "GNG5", target: "CXCR4", weight: 1 } },
    {
      data: { id: "UBAP2L-BAP1", source: "UBAP2L", target: "BAP1", weight: 1 },
    },
    { data: { id: "PTPN13-SRC", source: "PTPN13", target: "SRC", weight: 1 } },
    {
      data: { id: "STK4-RASSF1", source: "STK4", target: "RASSF1", weight: 1 },
    },
    {
      data: { id: "STK3-RASSF1", source: "STK3", target: "RASSF1", weight: 1 },
    },
    {
      data: { id: "TLE3-CTNNB1", source: "TLE3", target: "CTNNB1", weight: 1 },
    },
    {
      data: {
        id: "NUP214-SMAD4",
        source: "NUP214",
        target: "SMAD4",
        weight: 1,
      },
    },
    { data: { id: "TLE1-MYC", source: "TLE1", target: "MYC", weight: 1 } },
    {
      data: { id: "TLE1-CTNNB1", source: "TLE1", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "TLE1-SMAD4", source: "TLE1", target: "SMAD4", weight: 1 } },
    { data: { id: "PRKACA-RET", source: "PRKACA", target: "RET", weight: 1 } },
    {
      data: {
        id: "PRKACA-CTNNB1",
        source: "PRKACA",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: {
        id: "GTF2F2-METTL3",
        source: "GTF2F2",
        target: "METTL3",
        weight: 1,
      },
    },
    {
      data: { id: "NDUFAF2-MYC", source: "NDUFAF2", target: "MYC", weight: 1 },
    },
    {
      data: { id: "SNIP1-SMAD4", source: "SNIP1", target: "SMAD4", weight: 1 },
    },
    {
      data: { id: "PLOD2-SETD2", source: "PLOD2", target: "SETD2", weight: 1 },
    },
    { data: { id: "ITGB1-SRC", source: "ITGB1", target: "SRC", weight: 1 } },
    { data: { id: "ITGB1-PTEN", source: "ITGB1", target: "PTEN", weight: 1 } },
    { data: { id: "ITGB1-MYC", source: "ITGB1", target: "MYC", weight: 1 } },
    { data: { id: "ITGB1-EGFR", source: "ITGB1", target: "EGFR", weight: 1 } },
    { data: { id: "ARF6-MET", source: "ARF6", target: "MET", weight: 1 } },
    { data: { id: "ARF6-SRC", source: "ARF6", target: "SRC", weight: 1 } },
    { data: { id: "ARF6-EGFR", source: "ARF6", target: "EGFR", weight: 1 } },
    { data: { id: "AP2M1-EGFR", source: "AP2M1", target: "EGFR", weight: 1 } },
    { data: { id: "RAB5C-EGFR", source: "RAB5C", target: "EGFR", weight: 1 } },
    { data: { id: "AP2A2-EGFR", source: "AP2A2", target: "EGFR", weight: 1 } },
    { data: { id: "RHOA-MYC", source: "RHOA", target: "MYC", weight: 1 } },
    { data: { id: "RHOA-SRC", source: "RHOA", target: "SRC", weight: 1 } },
    {
      data: { id: "RHOA-CTNNB1", source: "RHOA", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "RHOA-MET", source: "RHOA", target: "MET", weight: 1 } },
    { data: { id: "RHOA-EGFR", source: "RHOA", target: "EGFR", weight: 1 } },
    {
      data: { id: "CSNK2B-TP53", source: "CSNK2B", target: "TP53", weight: 1 },
    },
    { data: { id: "POLA1-TP53", source: "POLA1", target: "TP53", weight: 1 } },
    { data: { id: "MOV10-PTEN", source: "MOV10", target: "PTEN", weight: 1 } },
    { data: { id: "MOV10-MYC", source: "MOV10", target: "MYC", weight: 1 } },
    { data: { id: "MOV10-TP53", source: "MOV10", target: "TP53", weight: 1 } },
    { data: { id: "DNMT1-TP53", source: "DNMT1", target: "TP53", weight: 1 } },
    { data: { id: "HDAC2-BAP1", source: "HDAC2", target: "BAP1", weight: 1 } },
    {
      data: { id: "HDAC2-SETD2", source: "HDAC2", target: "SETD2", weight: 1 },
    },
    {
      data: {
        id: "HDAC2-CTNNB1",
        source: "HDAC2",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: { id: "HDAC2-SMAD4", source: "HDAC2", target: "SMAD4", weight: 1 },
    },
    { data: { id: "HDAC2-TP53", source: "HDAC2", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-TP53", source: "DNA2", target: "TP53", weight: 1 } },
    { data: { id: "GPX1-TP53", source: "GPX1", target: "TP53", weight: 1 } },
    {
      data: { id: "INHBE-SMAD4", source: "INHBE", target: "SMAD4", weight: 1 },
    },
    {
      data: {
        id: "RAB7A-CTNNB1",
        source: "RAB7A",
        target: "CTNNB1",
        weight: 1,
      },
    },
    { data: { id: "BRD4-MYC", source: "BRD4", target: "MYC", weight: 1 } },
    {
      data: {
        id: "SLC9A3R1-EGFR",
        source: "SLC9A3R1",
        target: "EGFR",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-PTEN",
        source: "SLC9A3R1",
        target: "PTEN",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-CTNNB1",
        source: "CSNK2A2",
        target: "CTNNB1",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-TP53",
        source: "CSNK2A2",
        target: "TP53",
        weight: 1,
      },
    },
    {
      data: {
        id: "TMED5-WNT10A",
        source: "TMED5",
        target: "WNT10A",
        weight: 1,
      },
    },
    { data: { id: "RNF41-RET", source: "RNF41", target: "RET", weight: 1 } },
    { data: { id: "RNF41-MET", source: "RNF41", target: "MET", weight: 1 } },
    { data: { id: "RNF41-EGFR", source: "RNF41", target: "EGFR", weight: 1 } },
    {
      data: { id: "RNF41-HACE1", source: "RNF41", target: "HACE1", weight: 1 },
    },
    { data: { id: "RNF41-VHL", source: "RNF41", target: "VHL", weight: 1 } },
    { data: { id: "ELOB-HACE1", source: "ELOB", target: "HACE1", weight: 1 } },
    { data: { id: "ELOB-VHL", source: "ELOB", target: "VHL", weight: 1 } },
    {
      data: {
        id: "HECTD1-HACE1",
        source: "HECTD1",
        target: "HACE1",
        weight: 1,
      },
    },
    { data: { id: "HECTD1-VHL", source: "HECTD1", target: "VHL", weight: 1 } },
    {
      data: {
        id: "LRRC41-HACE1",
        source: "LRRC41",
        target: "HACE1",
        weight: 1,
      },
    },
    { data: { id: "LRRC41-VHL", source: "LRRC41", target: "VHL", weight: 1 } },
    { data: { id: "ELOC-HACE1", source: "ELOC", target: "HACE1", weight: 1 } },
    { data: { id: "ELOC-VHL", source: "ELOC", target: "VHL", weight: 1 } },
    {
      data: {
        id: "TRIM32-HACE1",
        source: "TRIM32",
        target: "HACE1",
        weight: 1,
      },
    },
    { data: { id: "TRIM32-VHL", source: "TRIM32", target: "VHL", weight: 1 } },
    {
      data: { id: "HERC2-HACE1", source: "HERC2", target: "HACE1", weight: 1 },
    },
    { data: { id: "HERC2-VHL", source: "HERC2", target: "VHL", weight: 1 } },
    { data: { id: "MARK3-KRAS", source: "MARK3", target: "KRAS", weight: 1 } },
    {
      data: { id: "AKAP9-KANK1", source: "AKAP9", target: "KANK1", weight: 1 },
    },
    { data: { id: "AKAP9-KRAS", source: "AKAP9", target: "KRAS", weight: 1 } },
    { data: { id: "GDF15-TP53", source: "GDF15", target: "TP53", weight: 1 } },
    { data: { id: "FBXL12-VHL", source: "FBXL12", target: "VHL", weight: 1 } },
    {
      data: {
        id: "FBXL12-HACE1",
        source: "FBXL12",
        target: "HACE1",
        weight: 1,
      },
    },
    {
      data: {
        id: "DCTPP1-NT5C1A",
        source: "DCTPP1",
        target: "NT5C1A",
        weight: 1,
      },
    },
    {
      data: {
        id: "IMPDH2-NT5C1A",
        source: "IMPDH2",
        target: "NT5C1A",
        weight: 1,
      },
    },
    {
      data: { id: "TLE5-CTNNB1", source: "TLE5", target: "CTNNB1", weight: 1 },
    },
    { data: { id: "TLE5-MYC", source: "TLE5", target: "MYC", weight: 1 } },
    { data: { id: "RBX1-VHL", source: "RBX1", target: "VHL", weight: 1 } },
    { data: { id: "RBX1-HACE1", source: "RBX1", target: "HACE1", weight: 1 } },
    { data: { id: "PSMD8-BAP1", source: "PSMD8", target: "BAP1", weight: 1 } },
    { data: { id: "PSMD8-TP53", source: "PSMD8", target: "TP53", weight: 1 } },
    { data: { id: "RALA-SRC", source: "RALA", target: "SRC", weight: 1 } },
    { data: { id: "RALA-KRAS", source: "RALA", target: "KRAS", weight: 1 } },
  ],
};

export const net_stomach = {
  nodes: [
    {
      data: {
        id: "TRIM29",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 36.34241,
      },
      position: { x: 91.2437632470955, y: 650.596648955456 },
    },
    {
      data: { id: "HLA-G", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: 214.270205871442, y: 579.996495749941 },
    },
    {
      data: { id: "NOTCH4", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -759.811070450702, y: -721.289292397404 },
    },
    {
      data: { id: "TYK2", oncg: 0, tsg: 0, driv: 0, type: "red", size: 40 },
      position: { x: -1023.21062655051, y: -126.881661780857 },
    },
    {
      data: { id: "CSDE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 607.576113694736 },
    },
    {
      data: { id: "PMPCA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 228.624006230158 },
    },
    {
      data: {
        id: "SOD2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -1158.53971343729, y: 93.3560741185857 },
    },
    {
      data: { id: "MARK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1158.64930276527, y: -877.46553487396 },
    },
    {
      data: { id: "PRIM1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -945.863996914479 },
    },
    {
      data: {
        id: "RASSF1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 1492.70730724715, y: -67.779970081269 },
    },
    {
      data: { id: "HECTD1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -712.058885063444 },
    },
    {
      data: { id: "CEP55", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -1004.31527487724 },
    },
    {
      data: { id: "CENPF", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -828.961440988962 },
    },
    {
      data: { id: "TRIM32", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -536.705051175169 },
    },
    {
      data: {
        id: "CDK5",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 1238.35382835689, y: 510.484034398605 },
    },
    {
      data: {
        id: "CDK5RAP2",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: 1175.63176205642, y: 627.145708478026 },
    },
    {
      data: { id: "LRRC41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -887.41271895172 },
    },
    {
      data: { id: "NUP214", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: -2.06347581069295 },
    },
    {
      data: {
        id: "FGFR2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 47.02669,
      },
      position: { x: -936.148971545599, y: -946.352527354475 },
    },
    {
      data: { id: "GTF2F2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -965.057685034609 },
    },
    {
      data: {
        id: "SIRT7",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 274.6228808213, y: -57.3313376048374 },
    },
    {
      data: { id: "TBK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -7.83656840639674, y: 647.244108646354 },
    },
    {
      data: { id: "NOL10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 554.483446889326, y: 711.32390230922 },
    },
    {
      data: { id: "NGDN", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 554.483446889326, y: 495.595624819327 },
    },
    {
      data: {
        id: "PDX1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -370.677781229955, y: -171.177145811787 },
    },
    {
      data: { id: "MEPCE", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 554.483446889326, y: 567.505050649301 },
    },
    {
      data: {
        id: "SYK",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -936.148971545599, y: -472.34863369681 },
    },
    {
      data: { id: "IBTK", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -570.749262002311 },
    },
    {
      data: {
        id: "PTGDR",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -370.677781229955, y: -253.813927979791 },
    },
    {
      data: {
        id: "FPR1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 624.840809953968, y: -670.285824189947 },
    },
    {
      data: {
        id: "MET",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 58.48035,
      },
      position: { x: -936.148971545599, y: -783.04513530336 },
    },
    {
      data: {
        id: "CASR",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 624.840809953968, y: -601.645646247454 },
    },
    {
      data: { id: "NDUFAF2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 683.366535187651 },
    },
    {
      data: { id: "SNIP1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: -239.041404838894 },
    },
    {
      data: { id: "NLRX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -7.83656840639674, y: 735.2475259769 },
    },
    {
      data: { id: "ELOC", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -1062.76655284 },
    },
    {
      data: { id: "STK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1361.49388501948, y: -98.5568415707397 },
    },
    {
      data: { id: "STK4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1361.49388501948, y: -16.9480917565191 },
    },
    {
      data: {
        id: "YAP1",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 44.4796,
      },
      position: { x: 1470.12894947057, y: 220.197642508992 },
    },
    {
      data: { id: "SAV1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1356.65186358846, y: 231.126753346744 },
    },
    {
      data: { id: "AP2M1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -728.47263121523 },
    },
    {
      data: { id: "RAB5C", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -807.33431582169 },
    },
    {
      data: { id: "AP2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -649.610946608771 },
    },
    {
      data: { id: "PLOD2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: -316.831809712171 },
    },
    {
      data: {
        id: "SETD7",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -1158.53971343729, y: -149.716702890672 },
    },
    {
      data: { id: "RNF41", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -886.196000428149 },
    },
    {
      data: {
        id: "ERBB2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 70.60697,
      },
      position: { x: -936.148971545599, y: -627.696884500085 },
    },
    {
      data: { id: "CSNK2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: 23.1096750239192 },
    },
    {
      data: { id: "POLA1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: -112.866918870517 },
    },
    {
      data: { id: "DNA2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: 159.086268918355 },
    },
    {
      data: { id: "GPX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: 227.074565865573 },
    },
    {
      data: {
        id: "SMAD4",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 274.6228808213, y: -192.896769715052 },
    },
    {
      data: { id: "INHBE", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: -160.048761829494 },
    },
    {
      data: {
        id: "STAT3",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: -1158.53971343729, y: -63.0378064629266 },
    },
    {
      data: { id: "PTPN13", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: -248.843512764953 },
    },
    {
      data: { id: "ITGB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 380.204849215989 },
    },
    {
      data: { id: "GNG5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 491.612071612401, y: -639.53734375481 },
    },
    {
      data: { id: "F2RL1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 491.612071612401, y: -553.658274605054 },
    },
    {
      data: { id: "BRD4", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 531.78569220182 },
    },
    {
      data: {
        id: "TCF3",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: 1017.09567459244, y: 500.110408799514 },
    },
    {
      data: { id: "TCF12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 941.082181052375, y: 625.112522551501 },
    },
    {
      data: {
        id: "EGFR",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 56.87734,
      },
      position: { x: -936.148971545599, y: -868.678401952838 },
    },
    {
      data: {
        id: "PTEN",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 48.20285,
      },
      position: { x: -649.107617491593, y: 333.406262928568 },
    },
    {
      data: {
        id: "SLC9A3R1",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: -780.172810460503, y: 304.414427723074 },
    },
    {
      data: { id: "CSNK2A2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: -44.8786219232989 },
    },
    {
      data: { id: "ELOB", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -595.156329137927 },
    },
    {
      data: { id: "RAB7A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: -318.034047848295 },
    },
    {
      data: { id: "DNMT1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: -180.855215817735 },
    },
    {
      data: {
        id: "CDH1",
        oncg: 1,
        tsg: 1,
        driv: 1,
        type: "lightblue",
        size: 69.52053,
      },
      position: { x: 274.6228808213, y: -260.679485770159 },
    },
    {
      data: { id: "HERC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -653.607607100686 },
    },
    {
      data: {
        id: "MARK2",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 1302.85839467663, y: -791.296006418635 },
    },
    {
      data: { id: "MIB1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1158.64930276527, y: -801.776429843724 },
    },
    {
      data: { id: "RIPK1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -7.83656840639674, y: 471.237273985263 },
    },
    {
      data: {
        id: "TRIM25",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 89.1933225366897, y: 527.850308938078 },
    },
    {
      data: { id: "EIF4E2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -7.83656840639674, y: 559.240691315808 },
    },
    {
      data: { id: "REEP5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: -206.772814740778 },
    },
    {
      data: { id: "TLE3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: -131.253633103235 },
    },
    {
      data: { id: "MARK3", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1158.64930276527, y: -726.087324813458 },
    },
    {
      data: { id: "AKAP9", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1158.64930276527, y: -650.398219783251 },
    },
    {
      data: { id: "PRKAR2B", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -460.954814541104, y: -46.7411477480112 },
    },
    {
      data: {
        id: "PPP1R1B",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -370.677781229955, y: -88.540363643755 },
    },
    {
      data: { id: "PRKAR2A", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -460.954814541104, y: -150.463239741918 },
    },
    {
      data: { id: "GDF15", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1289.4776849795, y: 91.0979719711371 },
    },
    {
      data: { id: "FBXL12", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -255.742607061004, y: -770.510163026203 },
    },
    {
      data: {
        id: "RRAS",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: -936.148971545599, y: -705.371009901722 },
    },
    {
      data: {
        id: "MPHOSPH10",
        oncg: 0,
        tsg: 0,
        driv: 0,
        type: "pink",
        size: 40,
      },
      position: { x: 554.483446889326, y: 423.686198989353 },
    },
    {
      data: {
        id: "SPARC",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 624.840809953968, y: -876.206358017569 },
    },
    {
      data: { id: "FBLN5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1341.44605425976, y: -405.163623962323 },
    },
    {
      data: {
        id: "LOX",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 1467.39311008986, y: -357.186645972846 },
    },
    {
      data: { id: "FBN1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1341.44605425976, y: -294.688498341313 },
    },
    {
      data: { id: "PRKACA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -460.954814541104, y: -254.185331735825 },
    },
    {
      data: { id: "MOV10", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 455.995270708905 },
    },
    {
      data: { id: "TLE1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: 95.3039118093926 },
    },
    {
      data: { id: "ERC1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: 19.78473017185 },
    },
    {
      data: {
        id: "LARP7",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 673.482302543104, y: 521.331884835464 },
    },
    {
      data: { id: "RBM28", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 554.483446889326, y: 639.414476479246 },
    },
    {
      data: { id: "ARF6", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 491.612071612401, y: -811.295482054264 },
    },
    {
      data: {
        id: "HGF",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 40,
      },
      position: { x: 624.840809953968, y: -807.566180075019 },
    },
    {
      data: { id: "SCCPDH", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 491.612071612401, y: -897.174551203991 },
    },
    {
      data: {
        id: "MYC",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 78.29735,
      },
      position: { x: -649.107617491593, y: 436.641233172652 },
    },
    {
      data: {
        id: "RUNX1",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 274.6228808213, y: -125.114053659945 },
    },
    {
      data: { id: "TLE5", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -780.172810460503, y: 759.156956680567 },
    },
    {
      data: {
        id: "SALL4",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 34.19952,
      },
      position: { x: 1478.69120542171, y: 502.058069336492 },
    },
    {
      data: { id: "NSD2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1398.01951293433, y: 625.260413362897 },
    },
    {
      data: {
        id: "DTL",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -132.040999135461, y: -864.814231376037 },
    },
    {
      data: { id: "RBX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: -282.291996378321 },
    },
    {
      data: { id: "HDAC2", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: -81.0561188200932 },
    },
    {
      data: {
        id: "CBX7",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: 274.6228808213, y: 10.4513784502698 },
    },
    {
      data: { id: "UBAP2L", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 132.772369514986, y: 76.9291671987074 },
    },
    {
      data: {
        id: "PIK3CA",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 624.840809953968, y: -738.926002132497 },
    },
    {
      data: { id: "HMOX1", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 491.612071612401, y: -725.416412904537 },
    },
    {
      data: {
        id: "CDKN1A",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: 891.5270511388, y: -47.3469050466738 },
    },
    {
      data: {
        id: "APC",
        oncg: 0,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 38.25862,
      },
      position: { x: 891.5270511388, y: -137.02889056712 },
    },
    {
      data: {
        id: "TP53",
        oncg: 1,
        tsg: 1,
        driv: 0,
        type: "lightblue",
        size: 59.24992,
      },
      position: { x: -1158.53971343729, y: 15.1591338278441 },
    },
    {
      data: {
        id: "CCND1",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -649.107617491593, y: 539.876203416678 },
    },
    {
      data: {
        id: "UBE2C",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 28.84499,
      },
      position: { x: -132.040999135461, y: -768.003590152963 },
    },
    {
      data: { id: "PSMD8", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 745.388411836504, y: -55.7344514656927 },
    },
    {
      data: {
        id: "CDH17",
        oncg: 1,
        tsg: 0,
        driv: 0,
        type: "lightblue",
        size: 31.74802,
      },
      position: { x: -936.148971545599, y: -550.022759098448 },
    },
    {
      data: { id: "RHOA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: -1089.47755165709, y: -491.887577395852 },
    },
    {
      data: {
        id: "KRAS",
        oncg: 1,
        tsg: 0,
        driv: 1,
        type: "lightblue",
        size: 57.68998,
      },
      position: { x: 1302.85839467663, y: -682.706773442995 },
    },
    {
      data: { id: "RALA", oncg: 0, tsg: 0, driv: 0, type: "pink", size: 40 },
      position: { x: 1158.64930276527, y: -574.709114753014 },
    },
  ],

  edges: [
    {
      data: {
        id: "HLA-G-TRIM29",
        source: "HLA-G",
        target: "TRIM29",
        weight: 1,
      },
    },
    {
      data: {
        id: "HLA-G-TRIM25",
        source: "HLA-G",
        target: "TRIM25",
        weight: 1,
      },
    },
    {
      data: { id: "NOTCH4-EGFR", source: "NOTCH4", target: "EGFR", weight: 1 },
    },
    {
      data: {
        id: "NOTCH4-ERBB2",
        source: "NOTCH4",
        target: "ERBB2",
        weight: 1,
      },
    },
    { data: { id: "TYK2-STAT3", source: "TYK2", target: "STAT3", weight: 1 } },
    {
      data: { id: "TYK2-PIK3CA", source: "TYK2", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "CSDE1-MYC", source: "CSDE1", target: "MYC", weight: 1 } },
    { data: { id: "PMPCA-PTEN", source: "PMPCA", target: "PTEN", weight: 1 } },
    {
      data: { id: "MARK1-MARK2", source: "MARK1", target: "MARK2", weight: 1 },
    },
    { data: { id: "PRIM1-DTL", source: "PRIM1", target: "DTL", weight: 1 } },
    {
      data: {
        id: "HECTD1-UBE2C",
        source: "HECTD1",
        target: "UBE2C",
        weight: 1,
      },
    },
    { data: { id: "CEP55-DTL", source: "CEP55", target: "DTL", weight: 1 } },
    {
      data: { id: "CEP55-UBE2C", source: "CEP55", target: "UBE2C", weight: 1 },
    },
    { data: { id: "CENPF-DTL", source: "CENPF", target: "DTL", weight: 1 } },
    {
      data: { id: "CENPF-UBE2C", source: "CENPF", target: "UBE2C", weight: 1 },
    },
    {
      data: {
        id: "TRIM32-UBE2C",
        source: "TRIM32",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: {
        id: "CDK5RAP2-CDK5",
        source: "CDK5RAP2",
        target: "CDK5",
        weight: 1,
      },
    },
    {
      data: {
        id: "LRRC41-UBE2C",
        source: "LRRC41",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: {
        id: "NUP214-SMAD4",
        source: "NUP214",
        target: "SMAD4",
        weight: 1,
      },
    },
    {
      data: {
        id: "GTF2F2-FGFR2",
        source: "GTF2F2",
        target: "FGFR2",
        weight: 1,
      },
    },
    {
      data: { id: "TBK1-TRIM25", source: "TBK1", target: "TRIM25", weight: 1 },
    },
    {
      data: { id: "NOL10-LARP7", source: "NOL10", target: "LARP7", weight: 1 },
    },
    { data: { id: "NGDN-LARP7", source: "NGDN", target: "LARP7", weight: 1 } },
    {
      data: { id: "MEPCE-LARP7", source: "MEPCE", target: "LARP7", weight: 1 },
    },
    { data: { id: "IBTK-SYK", source: "IBTK", target: "SYK", weight: 1 } },
    {
      data: { id: "NDUFAF2-MYC", source: "NDUFAF2", target: "MYC", weight: 1 },
    },
    {
      data: { id: "SNIP1-SMAD4", source: "SNIP1", target: "SMAD4", weight: 1 },
    },
    {
      data: {
        id: "NLRX1-TRIM25",
        source: "NLRX1",
        target: "TRIM25",
        weight: 1,
      },
    },
    { data: { id: "ELOC-UBE2C", source: "ELOC", target: "UBE2C", weight: 1 } },
    {
      data: { id: "STK3-RASSF1", source: "STK3", target: "RASSF1", weight: 1 },
    },
    { data: { id: "STK3-YAP1", source: "STK3", target: "YAP1", weight: 1 } },
    {
      data: { id: "STK4-RASSF1", source: "STK4", target: "RASSF1", weight: 1 },
    },
    { data: { id: "STK4-YAP1", source: "STK4", target: "YAP1", weight: 1 } },
    { data: { id: "SAV1-YAP1", source: "SAV1", target: "YAP1", weight: 1 } },
    { data: { id: "AP2M1-EGFR", source: "AP2M1", target: "EGFR", weight: 1 } },
    { data: { id: "RAB5C-EGFR", source: "RAB5C", target: "EGFR", weight: 1 } },
    { data: { id: "AP2A2-EGFR", source: "AP2A2", target: "EGFR", weight: 1 } },
    {
      data: { id: "PLOD2-SETD7", source: "PLOD2", target: "SETD7", weight: 1 },
    },
    {
      data: { id: "RNF41-FGFR2", source: "RNF41", target: "FGFR2", weight: 1 },
    },
    {
      data: { id: "RNF41-UBE2C", source: "RNF41", target: "UBE2C", weight: 1 },
    },
    { data: { id: "RNF41-MET", source: "RNF41", target: "MET", weight: 1 } },
    { data: { id: "RNF41-EGFR", source: "RNF41", target: "EGFR", weight: 1 } },
    {
      data: { id: "RNF41-ERBB2", source: "RNF41", target: "ERBB2", weight: 1 },
    },
    {
      data: { id: "CSNK2B-TP53", source: "CSNK2B", target: "TP53", weight: 1 },
    },
    { data: { id: "POLA1-TP53", source: "POLA1", target: "TP53", weight: 1 } },
    { data: { id: "DNA2-TP53", source: "DNA2", target: "TP53", weight: 1 } },
    { data: { id: "GPX1-SOD2", source: "GPX1", target: "SOD2", weight: 1 } },
    { data: { id: "GPX1-TP53", source: "GPX1", target: "TP53", weight: 1 } },
    {
      data: { id: "INHBE-SMAD4", source: "INHBE", target: "SMAD4", weight: 1 },
    },
    {
      data: {
        id: "PTPN13-STAT3",
        source: "PTPN13",
        target: "STAT3",
        weight: 1,
      },
    },
    { data: { id: "ITGB1-PTEN", source: "ITGB1", target: "PTEN", weight: 1 } },
    { data: { id: "ITGB1-MYC", source: "ITGB1", target: "MYC", weight: 1 } },
    { data: { id: "ITGB1-EGFR", source: "ITGB1", target: "EGFR", weight: 1 } },
    {
      data: {
        id: "ITGB1-PIK3CA",
        source: "ITGB1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    { data: { id: "GNG5-CASR", source: "GNG5", target: "CASR", weight: 1 } },
    { data: { id: "GNG5-PTGDR", source: "GNG5", target: "PTGDR", weight: 1 } },
    { data: { id: "GNG5-FPR1", source: "GNG5", target: "FPR1", weight: 1 } },
    {
      data: { id: "GNG5-PIK3CA", source: "GNG5", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "F2RL1-CASR", source: "F2RL1", target: "CASR", weight: 1 } },
    {
      data: {
        id: "F2RL1-PIK3CA",
        source: "F2RL1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    { data: { id: "BRD4-MYC", source: "BRD4", target: "MYC", weight: 1 } },
    { data: { id: "TCF12-TCF3", source: "TCF12", target: "TCF3", weight: 1 } },
    {
      data: {
        id: "SLC9A3R1-EGFR",
        source: "SLC9A3R1",
        target: "EGFR",
        weight: 1,
      },
    },
    {
      data: {
        id: "SLC9A3R1-PTEN",
        source: "SLC9A3R1",
        target: "PTEN",
        weight: 1,
      },
    },
    {
      data: {
        id: "CSNK2A2-TP53",
        source: "CSNK2A2",
        target: "TP53",
        weight: 1,
      },
    },
    { data: { id: "ELOB-UBE2C", source: "ELOB", target: "UBE2C", weight: 1 } },
    { data: { id: "RAB7A-CDH1", source: "RAB7A", target: "CDH1", weight: 1 } },
    {
      data: { id: "DNMT1-SETD7", source: "DNMT1", target: "SETD7", weight: 1 },
    },
    { data: { id: "DNMT1-TP53", source: "DNMT1", target: "TP53", weight: 1 } },
    {
      data: { id: "DNMT1-STAT3", source: "DNMT1", target: "STAT3", weight: 1 },
    },
    { data: { id: "DNMT1-CDH1", source: "DNMT1", target: "CDH1", weight: 1 } },
    {
      data: { id: "HERC2-UBE2C", source: "HERC2", target: "UBE2C", weight: 1 },
    },
    { data: { id: "MIB1-MARK2", source: "MIB1", target: "MARK2", weight: 1 } },
    {
      data: {
        id: "RIPK1-TRIM25",
        source: "RIPK1",
        target: "TRIM25",
        weight: 1,
      },
    },
    {
      data: {
        id: "EIF4E2-TRIM25",
        source: "EIF4E2",
        target: "TRIM25",
        weight: 1,
      },
    },
    { data: { id: "REEP5-APC", source: "REEP5", target: "APC", weight: 1 } },
    { data: { id: "TLE3-APC", source: "TLE3", target: "APC", weight: 1 } },
    {
      data: { id: "MARK3-MARK2", source: "MARK3", target: "MARK2", weight: 1 },
    },
    { data: { id: "MARK3-KRAS", source: "MARK3", target: "KRAS", weight: 1 } },
    { data: { id: "AKAP9-KRAS", source: "AKAP9", target: "KRAS", weight: 1 } },
    {
      data: {
        id: "PRKAR2B-PPP1R1B",
        source: "PRKAR2B",
        target: "PPP1R1B",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKAR2A-PPP1R1B",
        source: "PRKAR2A",
        target: "PPP1R1B",
        weight: 1,
      },
    },
    { data: { id: "GDF15-TP53", source: "GDF15", target: "TP53", weight: 1 } },
    {
      data: {
        id: "FBXL12-UBE2C",
        source: "FBXL12",
        target: "UBE2C",
        weight: 1,
      },
    },
    {
      data: {
        id: "MPHOSPH10-LARP7",
        source: "MPHOSPH10",
        target: "LARP7",
        weight: 1,
      },
    },
    { data: { id: "FBLN5-LOX", source: "FBLN5", target: "LOX", weight: 1 } },
    { data: { id: "FBN1-LOX", source: "FBN1", target: "LOX", weight: 1 } },
    {
      data: { id: "PRKACA-PDX1", source: "PRKACA", target: "PDX1", weight: 1 },
    },
    {
      data: {
        id: "PRKACA-PTGDR",
        source: "PRKACA",
        target: "PTGDR",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-ERBB2",
        source: "PRKACA",
        target: "ERBB2",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-PPP1R1B",
        source: "PRKACA",
        target: "PPP1R1B",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CDKN1A",
        source: "PRKACA",
        target: "CDKN1A",
        weight: 1,
      },
    },
    {
      data: {
        id: "PRKACA-CCND1",
        source: "PRKACA",
        target: "CCND1",
        weight: 1,
      },
    },
    { data: { id: "MOV10-PTEN", source: "MOV10", target: "PTEN", weight: 1 } },
    { data: { id: "MOV10-MYC", source: "MOV10", target: "MYC", weight: 1 } },
    { data: { id: "MOV10-TP53", source: "MOV10", target: "TP53", weight: 1 } },
    {
      data: { id: "MOV10-CCND1", source: "MOV10", target: "CCND1", weight: 1 },
    },
    { data: { id: "TLE1-MYC", source: "TLE1", target: "MYC", weight: 1 } },
    { data: { id: "TLE1-SMAD4", source: "TLE1", target: "SMAD4", weight: 1 } },
    { data: { id: "TLE1-APC", source: "TLE1", target: "APC", weight: 1 } },
    { data: { id: "TLE1-CCND1", source: "TLE1", target: "CCND1", weight: 1 } },
    {
      data: { id: "ERC1-CDKN1A", source: "ERC1", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "ERC1-CCND1", source: "ERC1", target: "CCND1", weight: 1 } },
    {
      data: { id: "RBM28-LARP7", source: "RBM28", target: "LARP7", weight: 1 },
    },
    { data: { id: "ARF6-MET", source: "ARF6", target: "MET", weight: 1 } },
    { data: { id: "ARF6-EGFR", source: "ARF6", target: "EGFR", weight: 1 } },
    {
      data: { id: "ARF6-PIK3CA", source: "ARF6", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "ARF6-HGF", source: "ARF6", target: "HGF", weight: 1 } },
    {
      data: {
        id: "SCCPDH-SPARC",
        source: "SCCPDH",
        target: "SPARC",
        weight: 1,
      },
    },
    { data: { id: "SCCPDH-HGF", source: "SCCPDH", target: "HGF", weight: 1 } },
    { data: { id: "TLE5-CCND1", source: "TLE5", target: "CCND1", weight: 1 } },
    { data: { id: "TLE5-MYC", source: "TLE5", target: "MYC", weight: 1 } },
    { data: { id: "TLE5-RUNX1", source: "TLE5", target: "RUNX1", weight: 1 } },
    { data: { id: "NSD2-SALL4", source: "NSD2", target: "SALL4", weight: 1 } },
    { data: { id: "RBX1-UBE2C", source: "RBX1", target: "UBE2C", weight: 1 } },
    { data: { id: "RBX1-DTL", source: "RBX1", target: "DTL", weight: 1 } },
    {
      data: { id: "RBX1-CDKN1A", source: "RBX1", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "RBX1-APC", source: "RBX1", target: "APC", weight: 1 } },
    {
      data: { id: "HDAC2-SMAD4", source: "HDAC2", target: "SMAD4", weight: 1 },
    },
    {
      data: { id: "HDAC2-SIRT7", source: "HDAC2", target: "SIRT7", weight: 1 },
    },
    {
      data: { id: "HDAC2-RUNX1", source: "HDAC2", target: "RUNX1", weight: 1 },
    },
    { data: { id: "HDAC2-TP53", source: "HDAC2", target: "TP53", weight: 1 } },
    { data: { id: "HDAC2-CDH1", source: "HDAC2", target: "CDH1", weight: 1 } },
    {
      data: {
        id: "HDAC2-CDKN1A",
        source: "HDAC2",
        target: "CDKN1A",
        weight: 1,
      },
    },
    { data: { id: "HDAC2-CBX7", source: "HDAC2", target: "CBX7", weight: 1 } },
    {
      data: { id: "UBAP2L-CBX7", source: "UBAP2L", target: "CBX7", weight: 1 },
    },
    {
      data: {
        id: "HMOX1-PIK3CA",
        source: "HMOX1",
        target: "PIK3CA",
        weight: 1,
      },
    },
    {
      data: {
        id: "PSMD8-CDKN1A",
        source: "PSMD8",
        target: "CDKN1A",
        weight: 1,
      },
    },
    { data: { id: "PSMD8-APC", source: "PSMD8", target: "APC", weight: 1 } },
    { data: { id: "PSMD8-TP53", source: "PSMD8", target: "TP53", weight: 1 } },
    {
      data: { id: "PSMD8-CCND1", source: "PSMD8", target: "CCND1", weight: 1 },
    },
    {
      data: { id: "PSMD8-UBE2C", source: "PSMD8", target: "UBE2C", weight: 1 },
    },
    { data: { id: "RHOA-MYC", source: "RHOA", target: "MYC", weight: 1 } },
    { data: { id: "RHOA-SYK", source: "RHOA", target: "SYK", weight: 1 } },
    { data: { id: "RHOA-MET", source: "RHOA", target: "MET", weight: 1 } },
    { data: { id: "RHOA-EGFR", source: "RHOA", target: "EGFR", weight: 1 } },
    { data: { id: "RHOA-ERBB2", source: "RHOA", target: "ERBB2", weight: 1 } },
    {
      data: { id: "RHOA-PIK3CA", source: "RHOA", target: "PIK3CA", weight: 1 },
    },
    { data: { id: "RHOA-CDH1", source: "RHOA", target: "CDH1", weight: 1 } },
    { data: { id: "RHOA-RRAS", source: "RHOA", target: "RRAS", weight: 1 } },
    {
      data: { id: "RHOA-CDKN1A", source: "RHOA", target: "CDKN1A", weight: 1 },
    },
    { data: { id: "RHOA-CCND1", source: "RHOA", target: "CCND1", weight: 1 } },
    { data: { id: "RHOA-CDH17", source: "RHOA", target: "CDH17", weight: 1 } },
    { data: { id: "RALA-KRAS", source: "RALA", target: "KRAS", weight: 1 } },
  ],
};
